unit Unit1;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.ComCtrls, WEBLib.WebCtrls, Vcl.Imaging.pngimage,math,
  WEBLib.Buttons,NetEncoding, WEBLib.REST,WEBLib.JSON;

type
  TForm1 = class(TForm)
    WebPanel10: TPanel;
    WebImageHamburgerLeft: TImageControl;
    WebImageLogo: TImageControl;
    WebImageHamburgerRight: TImageControl;
    WPTopMenus: TPanel;
    WebHTMLContainer9: THTMLContainer;
    WPCMain: TPageControl;
    WebPageControlHome: TTabSheet;
    WRGMain: TResponsiveGridPanel;
    WebPanel2: TPanel;
    WebHTMLContainer1: THTMLContainer;
    WebPanel3: TPanel;
    WebHTMLContainer2: THTMLContainer;
    WebPanel4: TPanel;
    WebYoutube2: TYoutube;
    WebPanel5: TPanel;
    WebHTMLContainer3: THTMLContainer;
    WebPanel6: TPanel;
    WebHTMLContainer5: THTMLContainer;
    WebPanel7: TPanel;
    WebHTMLContainer6: THTMLContainer;
    WebPanel8: TPanel;
    WebPanel9: TPanel;
    WebPageControlSheetOther: TTabSheet;
    WebResponsiveGridPanel1: TResponsiveGridPanel;
    WebPanel11: TPanel;
    WebBrowserControl1: TBrowserControl;
    WebPanel12: TPanel;
    WebBrowserControl2: TBrowserControl;
    WebPanel13: TPanel;
    WebPanel14: TPanel;
    WebPanel15: TPanel;
    WebPanel16: TPanel;
    WebPanel17: TPanel;
    WebPanel18: TPanel;
    WebResponsiveGridPanel3: TResponsiveGridPanel;
    WebPanel26: TPanel;
    WebHTMLContainer4: THTMLContainer;
    WebPanel27: TPanel;
    WebHTMLContainer20: THTMLContainer;
    WebPanel28: TPanel;
    WebHTMLContainer26: THTMLContainer;
    WebPanel29: TPanel;
    WebHTMLContainer27: THTMLContainer;
    WebPanel30: TPanel;
    WebHTMLContainer28: THTMLContainer;
    WebPanel31: TPanel;
    WebHTMLContainer29: THTMLContainer;
    WebPanel32: TPanel;
    WebHTMLContainer30: THTMLContainer;
    WebPanel33: TPanel;
    WebHTMLContainer31: THTMLContainer;
    WebPageControlSheetLessons: TTabSheet;
    WebResponsiveGridPanel2: TResponsiveGridPanel;
    WebPanel19: TPanel;
    WebBrowserControl5: TBrowserControl;
    WebPanel20: TPanel;
    WebBrowserControl8: TBrowserControl;
    WebPanel21: TPanel;
    WebHTMLContainer12: THTMLContainer;
    WebPanel22: TPanel;
    WebHTMLContainer13: THTMLContainer;
    WebPanel23: TPanel;
    WebHTMLContainer7: THTMLContainer;
    WebPanel24: TPanel;
    WebHTMLContainer8: THTMLContainer;
    WebPanel25: TPanel;
    WebHTMLContainer10: THTMLContainer;
    WebPanel34: TPanel;
    WebHTMLContainer11: THTMLContainer;
    WPCMainSheetLogin: TTabSheet;
    WPCMainSheet5: TTabSheet;
    WPLeftMenu: TPanel;
    WebLinkLabel1: TLinkLabel;
    WebLinkLabel2: TLinkLabel;
    WebLinkLabel3: TLinkLabel;
    WebLinkLabel4: TLinkLabel;
    WebPanel1: TPanel;
    WebRadioGroup1: TRadioGroup;
    WebPanel35: TPanel;
    WebPageControlLogin: TPageControl;
    WebPageControl1Sheet1: TTabSheet;
    WebPanelLogin: TPanel;
    WebLabel1: TLabel;
    WebEditLoginEmail: TEdit;
    WebEditLoginPassword: TEdit;
    WebButtonLogin: TButton;
    WebPageControl1Sheet2: TTabSheet;
    WebPanelRegister: TPanel;
    WebEditRegisterEmail: TEdit;
    WebEditRegisterMobile: TEdit;
    WebEditRegisterPassword: TEdit;
    WebEditRegisterfirstName: TEdit;
    WebLinkLabel5: TLinkLabel;
    WebLabel2: TLabel;
    WebEditRegisterSurname: TEdit;
    WebButtonRegister: TButton;
    WebHttpRequestRegister: THttpRequest;
    WebButton1: TButton;
    WebButton2: TButton;
    WebImageControl1: TImageControl;
    WebButton3: TButton;
    procedure WebRadioButton1Click(Sender: TObject);
    procedure WebRadioButton2Click(Sender: TObject);
    procedure WebRadioButton3Click(Sender: TObject);
    procedure WebRadioButton4Click(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);

    procedure AddSlidingAnimationsCSS;
    procedure WebFormResize(Sender: TObject);
    procedure UpdateTextSizes;
    procedure WebFormShow(Sender: TObject);
    procedure ApplySlidingAnimation(const Panel: TPanel; const AnimationType: string);
    procedure WRGMainLayoutChange(Sender: TObject;
      ALayout: TResponsiveLayoutItem);
    procedure WebImageHamburgerLeftClick(Sender: TObject);
    procedure WebLinkLabel1Click(Sender: TObject);
    procedure WebLinkLabel2Click(Sender: TObject);
    procedure WebLinkLabel3Click(Sender: TObject);
    procedure WebRadioGroup1Change(Sender: TObject);
    procedure WebAccordionLoginExpanded(Sender: TObject;
      ASection: TAccordionSection);
    procedure WebLinkLabel4Click(Sender: TObject);
    procedure WebLinkLabel5Click(Sender: TObject);
    procedure WebButtonRegisterClick(Sender: TObject);
    procedure WebHttpRequestRegisterRequestResponse(Sender: TObject;
      ARequest: TJSXMLHttpRequestRecord; AResponse: string);
    procedure WebButton1Click(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure SetElementIDs;
    procedure WebHttpRequestRegisterError(Sender: TObject;
      ARequest: TJSXMLHttpRequestRecord; Event: TJSEventRecord;
      var Handled: Boolean);
    procedure WebHttpRequestRegisterResponse(Sender: TObject;
      AResponse: string);
    procedure WebButton3Click(Sender: TObject);
    procedure DisplayEasingAnimations;
    procedure ToggleWPLeftMenu;
  private
    { Private declarations }
  public
    { Public declarations }
    screenWidth : Integer;
  protected procedure LoadDFMValues; override; end;

var
  Form1: TForm1;

implementation

{$R *.dfm}
// https://bootswatch.com/lux/
procedure TForm1.WebAccordionLoginExpanded(Sender: TObject;
  ASection: TAccordionSection);
begin
    if Asection.ID = 0 then
    begin
      // close Asection 1
     // WebAccordionLogin.Sections[1].Expanded := false;//not WebAccordionLogin.Sections[1].Expanded;
    end;

    if Asection.ID = 1 then
    begin
      // close Asection 1
     // WebAccordionLogin.Sections[0].Expanded := false;//not WebAccordionLogin.Sections[0].Expanded;
    end;
end;

procedure TForm1.WebButton1Click(Sender: TObject);
var
  JsonToSend: string;
  JSONObj: TJSONObject;
begin
    JSONObj := TJSONObject.Create;
  try
    JSONObj.AddPair('username', WebEditRegisterEmail.Text);
    JSONObj.AddPair('password', 'myPassword');

    // Convert JSON object to string
    JsonToSend := JSONObj.ToString;
  finally
    JSONObj.Free;
  end;
 // JsonToSend := '{"username": "myUser","password": "myPassword"} ';
    WebHttpRequestRegister.Command := httpPOST; // Set the request method to POST

  // Set the request headers
  WebHttpRequestRegister.Headers.Clear;
  WebHttpRequestRegister.Headers.AddPair('Content-Type','application/json');
  // Set the request body
  WebHttpRequestRegister.PostData := JsonToSend;

  // Execute the request
  WebHttpRequestRegister.Execute();//
//


end;


procedure TForm1.WebButton2Click(Sender: TObject);
begin
      // Make WPLeftMenu visible and set initial width to 0
  //WPLeftMenu.Visible := True;
  //WPLeftMenu.Width := 0;  // Set width directly through ElementHandle
  ToggleWPLeftMenu;
//    WPCMain.ActivePageIndex := 0;
//    asm
//    scrollToElement('WebPanel9'); // Replace 'myPanelName' with the actual name of the panel
//    end;
end;

procedure TForm1.WebButton3Click(Sender: TObject);
begin

    DisplayEasingAnimations;

end;

procedure TForm1.WebButtonRegisterClick(Sender: TObject);
var
  JsonToSend: string;
  EncodedEmail, EncodedPassword: string;
begin
  // Create JSON string with user data
  EncodedEmail := WebEditRegisterEmail.Text;
  EncodedPassword := WebEditRegisterPassword.Text;
  // Encoding the email and password
  EncodedEmail := TNetEncoding.Base64.Encode(WebEditRegisterEmail.Text);
  EncodedPassword := TNetEncoding.Base64.Encode(WebEditRegisterPassword.Text);

  // Here you might want to send these encoded values to a server or handle them as needed
  //ShowMessage('Encoded Email: ' + EncodedEmail + ' Encoded Password: ' + EncodedPassword);
  JsonToSend := '{"username":"testuser", "password":"testpassword"}';

  // Set headers for JSON content type
  WebHttpRequestRegister.Headers.Clear;
  //WebHttpRequestRegister.Headers.Add('Content-Type: application/json');
  WebHttpRequestRegister.Headers.AddPair('Content-Type', 'application/json');
  // Set request body
  WebHttpRequestRegister.PostData :=  JsonToSend;
  WebHttpRequestRegister.Execute;



end;



procedure TForm1.WebFormCreate(Sender: TObject);

begin
    WPLeftMenu.Width := 0;
    SetElementIDs;
    Application.RemoveCSS('themecss')  ;
    Application.InsertCSS('themecss','slate/theme.css');
   // AddCSS('boutonSearch_active','.boutonSearch_active {border-radius: 24px;background-color: #D90B4D;border: 3px solid #D90B4D; color: white;cursor:pointer;}');
    //WebButtonLogin.ElementClassName   :=  'boutonSearch_active';
   // WebButtonRegister.ElementClassName   :=  'boutonSearch_active';

      // Add CSS for sliding animations
  WebImageHamburgerLeft.Visible := false;
  WPLeftMenu.Visible := false;
  AddSlidingAnimationsCSS;

  // Inline JavaScript using the asm block
  asm
    // IntersectionObserver setup
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          // Log the ID of the element that has come into view
          console.log(entry.target.id + ' has come into view');
        }
      });
    });

    // Select all elements with the class 'web-panel'
    var panels = document.querySelectorAll('.web-panel');
    console.log('Panels found:', panels.length); // Debugging line to ensure panels are found

    // Observe each panel for intersection changes
    panels.forEach(function(panel) {
      observer.observe(panel);
    });
  end;
end;

procedure TForm1.WebFormResize(Sender: TObject);
  var
  jsr: TJSDOMRect;
  panelWidth : Integer;
begin
  jsr := document.body.getBoundingClientRect;
  // Button into form

  // Button into Panel
    //panelWidth := Round(WebPanelRegister.Width * 0.75);
    //WebEditRegisterSurname.Text := panelWidth.ToString;
    //WebButtonRegister.Width := panelWidth;
    //WebButtonLogin.Width := panelWidth;

   // WebButtonLogin.AlignWithMargins := true;
    //WebButtonLogin.Left := Round((jsr.right - jsr.left - WebButtonLogin.Width) / 2) ;//- WebPanelLogin.Left);
    //WebButtonRegister.Left := Round(((jsr.right - jsr.left - WebButtonRegister.Width) / 2) - WebPanelRegister.Left);
    screenWidth := Form1.Width;
    UpdateTextSizes;
    if screenWidth < 450 then
    begin
      WPCMain.ShowTabs := false;
      WPTopMenus.Visible := false;
    end;
    if screenWidth > 450 then
    begin
      WPCMain.ShowTabs := true;
      WPTopMenus.Visible := true;
    end;

end;

procedure TForm1.WebFormShow(Sender: TObject);
var
  ImgURL,ImgURL1 , ImgURL2, ImgMainBack,StyleImg: String;
  PanelElement1, PanelElement2, PanelElement3,PanelElement4, PanelElement7, PanelElement10,WPLeftMenuElement,FormElementMain: TJSHTMLElement;
begin

// do the animations
  WPCMain.TabIndex := 0;
  ImgURL := 'https://wilsea.com/hseasy/images/backdropTall1.png';
  StyleImg := ';background-image: url('+ImgURL+');';
  StyleImg := document.body.getAttribute('style') + StyleImg;

  document.body.setAttribute('style',StyleImg);
  ApplySlidingAnimation(WebPanel1, 'slideInFromLeft');
  ApplySlidingAnimation(WebPanel2, 'slideInFromRight');
  ApplySlidingAnimation(WebPanel3, 'slideInFromLeft');
  ApplySlidingAnimation(WebPanel4, 'slideInFromRight');
  ApplySlidingAnimation(WebPanel5, 'slideInFromLeft');
  ApplySlidingAnimation(WebPanel6, 'slideInFromRight');
  ApplySlidingAnimation(WebPanel7, 'slideInFromLeft');
  ApplySlidingAnimation(WebPanel8, 'slideInFromRight');

  ApplySlidingAnimation(WebPanel9, 'slideInFromLeft');
  ApplySlidingAnimation(WebPanel11, 'slideInFromRight');
  ApplySlidingAnimation(WebPanel12, 'slideInFromLeft');
  ApplySlidingAnimation(WebPanel13, 'slideInFromRight');
  ApplySlidingAnimation(WebPanel14, 'slideInFromLeft');
  ApplySlidingAnimation(WebPanel15, 'slideInFromRight');
  ApplySlidingAnimation(WebPanel16, 'slideInFromLeft');
  ApplySlidingAnimation(WebPanel17, 'slideInFromRight');

  ApplySlidingAnimation(WebPanel18, 'slideInFromLeft');
  ApplySlidingAnimation(WebPanel19, 'slideInFromRight');
  ApplySlidingAnimation(WebPanel20, 'slideInFromLeft');
  ApplySlidingAnimation(WebPanel21, 'slideInFromRight');
  ApplySlidingAnimation(WebPanel22, 'slideInFromLeft');
  ApplySlidingAnimation(WebPanel23, 'slideInFromRight');
  ApplySlidingAnimation(WebPanel24, 'slideInFromLeft');
  ApplySlidingAnimation(WebPanel25, 'slideInFromRight');
  ApplySlidingAnimation(WebPanel35, 'slideInFromLeft');
  //UpdateTextSizes;
  ImgURL1 := 'https://wilsea.com/hseasy/images/backdropManHelmet1.png';
  ImgURL2 :=      'https://wilsea.com/hseasy/images/techBackground.png';
  ImgMainBack := 'https://wilsea.com/hseasy/images/backdrop1.png';

  // Access the panel element using its ElementID for WebPanel1
  PanelElement1 := TJSHTMLElement(document.getElementById(WebHTMLContainer1.ElementID));

  // Apply the background style to WebPanel1
  if Assigned(PanelElement1) then
  begin
    PanelElement1.style.setProperty('background-image', 'url(' + ImgURL1 + ')');
    PanelElement1.style.setProperty('background-size', 'cover'); // Ensure the image covers the whole panel
    PanelElement1.style.setProperty('background-position', 'center'); // Center the image
    //PanelElement1.style.setProperty('background:rgba(255,255,255,0.5)';
  end;

  // Access the panel element using its ElementID for WebPanel2
  PanelElement2 := TJSHTMLElement(document.getElementById(WebHTMLContainer2.ElementID));

  // Apply the background style to WebPanel2
  if Assigned(PanelElement2) then
  begin
    //PanelElement2.style.setProperty('background-image', 'url(' + ImgURL2   + ')');
    //PanelElement2.style.setProperty('background-size', 'cover'); // Ensure the image covers the whole panel
    //PanelElement2.style.setProperty('background-position', 'center'); // Center the image
  end;

  PanelElement3 := TJSHTMLElement(document.getElementById(WebHTMLContainer3.ElementID));

  // Apply the background style to WebPanel2
  if Assigned(PanelElement3) then
  begin
    //PanelElement3.style.setProperty('background-image', 'url(' + ImgMainBack   + ')');
    //PanelElement3.style.setProperty('background-size', 'cover'); // Ensure the image covers the whole panel
    //PanelElement3.style.setProperty('background-position', 'center'); // Center the image
  end;

    PanelElement4 := TJSHTMLElement(document.getElementById(WebHTMLContainer4.ElementID));

  // Apply the background style to WebPanel2
  if Assigned(PanelElement4) then
  begin
    PanelElement4.style.setProperty('background-image', 'url(' + ImgURL2   + ')');
    PanelElement4.style.setProperty('background-size', 'cover'); // Ensure the image covers the whole panel
    PanelElement4.style.setProperty('background-position', 'center'); // Center the image
  end;
  // Access the panel element using its ElementID for WebPanel2
    WPLeftMenuElement := TJSHTMLElement(document.getElementById(WPLeftMenu.ElementID));

  // Apply the background style to WebPanel1
  if Assigned(PanelElement10) then
  begin
    WPLeftMenuElement.style.setProperty('background-image', 'url(' + ImgMainBack + ')');
    WPLeftMenuElement.style.setProperty('background-size', 'cover'); // Ensure the image covers the whole panel
    WPLeftMenuElement.style.setProperty('background-position', 'center'); // Center the image
    //WPLeftMenu.style.setProperty('background:rgba(255,255,255,0.5)';
  end;

  FormElementMain := TJSHTMLElement(document.getElementById(Form1.ElementClassName));

  // Apply the background style to MainForm
  if Assigned(FormElementMain) then
  begin
    //FormElementMain.style.setProperty('background-image', 'url(' + ImgURL1   + ')');
   // FormElementMain.style.setProperty('background-size', 'cover'); // Ensure the image covers the whole panel
   // FormElementMain.style.setProperty('background-position', 'center'); // Center the image
  end;

end;

procedure TForm1.WebHttpRequestRegisterError(Sender: TObject;
  ARequest: TJSXMLHttpRequestRecord; Event: TJSEventRecord;
  var Handled: Boolean);
begin
     // ShowMessage('Error: ' + showmessage(ARequest.req.response.);//  .req.responseText); // Displays the error response from the server.

end;

procedure TForm1.WebHttpRequestRegisterRequestResponse(Sender: TObject;
  ARequest: TJSXMLHttpRequestRecord; AResponse: string);
var
  JSONObj: TJSONObject;
  JSONValue: TJSONValue;
  NameValue: string;
begin
      showmessage(ARequest.req.responseText);
     // showmessage(AResponse);
//  try
//    // Parse the JSON response
//    JSONObj := TJSONObject.ParseJSONValue(AResponse) as TJSONObject;
//    try
//      if JSONObj <> nil then
//      begin
//        // Attempt to retrieve the 'name' key value
//        JSONValue := JSONObj.GetValue('name');
//        if JSONValue <> nil then
//        begin
//          NameValue := JSONValue.Value;
//          ShowMessage('Name: ' + NameValue);
//        end
//        else
//          ShowMessage('Name key not found in JSON response.');
//      end
//      else
//        ShowMessage('Failed to parse JSON response.');
//    finally
//      JSONObj.Free;
//    end;
//  except
//    on E: Exception do
//      ShowMessage('Error processing JSON data: ' + E.Message);
//  end;
end;

procedure TForm1.WebHttpRequestRegisterResponse(Sender: TObject;
  AResponse: string);
begin
//    showmessage('Response = '+AResponse);
end;

procedure TForm1.WebImageHamburgerLeftClick(Sender: TObject);
begin
         ToggleWPLeftMenu;
         //WPLeftMenu.Visible := not WPLeftMenu.Visible;
         //WPLeftMenu.Width := Form1.Width;
         WPCMain.Visible := not WPCMain.Visible;
end;

procedure TForm1.WebLinkLabel1Click(Sender: TObject);
begin

        WPCMain.Visible := not WPCMain.Visible;
        //WPLeftMenu.Visible := not WPLeftMenu.Visible;
        WPCMain.TabIndex := 0 ;
        ToggleWPLeftMenu;
end;

procedure TForm1.WebLinkLabel2Click(Sender: TObject);
begin

        WPCMain.Visible := not WPCMain.Visible;
        WPCMain.TabIndex := 1 ;
        ToggleWPLeftMenu ;
end;

procedure TForm1.WebLinkLabel3Click(Sender: TObject);
begin

        WPCMain.Visible := not WPCMain.Visible;
        WPCMain.TabIndex := 2 ;
         ToggleWPLeftMenu;
end;

procedure TForm1.WebLinkLabel4Click(Sender: TObject);
begin

        WPCMain.Visible := not WPCMain.Visible;
        WPCMain.TabIndex := 3 ;
        ToggleWPLeftMenu ;
end;

procedure TForm1.WebLinkLabel5Click(Sender: TObject);
begin

        WPCMain.Visible := not WPCMain.Visible;
        WPCMain.TabIndex := 4 ;
         ToggleWPLeftMenu ;
end;

procedure TForm1.WebRadioButton1Click(Sender: TObject);
begin
        Application.RemoveCSS('themecss')  ;

    Application.InsertCSS('themecss','Minty/theme.css');
end;

procedure TForm1.WebRadioButton2Click(Sender: TObject);
begin
        Application.RemoveCSS('themecss')  ;

    Application.InsertCSS('themecss','cyborg/theme.css');
end;

procedure TForm1.WebRadioButton3Click(Sender: TObject);
begin
         Application.RemoveCSS('themecss')  ;

    Application.InsertCSS('themecss','darkly/theme.css');
end;

procedure TForm1.WebRadioButton4Click(Sender: TObject);
begin
             Application.RemoveCSS('themecss')  ;

    Application.InsertCSS('themecss','slate/theme.css');
end;

procedure TForm1.WebRadioGroup1Change(Sender: TObject);
begin
    //showmessage(WebRadioGroup1.ItemIndex.ToString);
    if WebRadioGroup1.ItemIndex = 0  then
    begin
      Application.RemoveCSS('themecss')  ;
      Application.InsertCSS('themecss','slate/theme.css');
    end;
    if WebRadioGroup1.ItemIndex = 1  then
    begin
      Application.RemoveCSS('themecss')  ;
      Application.InsertCSS('themecss','cyborg/theme.css');
    end;
    if WebRadioGroup1.ItemIndex = 2  then
    begin
      Application.RemoveCSS('themecss')  ;
      Application.InsertCSS('themecss','darkly/theme.css');
    end;
end;

procedure TForm1.WRGMainLayoutChange(Sender: TObject;
  ALayout: TResponsiveLayoutItem);
begin
    case ALayout.Index of
  0:
    begin

      WebImageHamburgerLeft.Visible := true;
      // WebPamels on first Tab
      WebPanel1.Height := 200;
      WebPanel2.Height := 200;
      WebPanel3.Height := 200;
      WebPanel4.Height := 200;
      WebPanel5.Height := 200;
      WebPanel6.Height := 200;
      WebPanel7.Height := 200;
      WebPanel8.Height := 200;
      // WebPamels on second Tab
      WebPanel9.Height := 500;
      WebPanel11.Height := 500;
      WebPanel12.Height := 500;
      WebPanel13.Height := 500;
      WebPanel14.Height := 500;
      WebPanel15.Height := 500;
      WebPanel16.Height := 500;
      WebPanel17.Height := 500;
      // WebPamels on third Tab
      WebPanel18.Height := 500;
      WebPanel19.Height := 500;
      WebPanel20.Height := 500;
      WebPanel21.Height := 500;
      WebPanel22.Height := 500;
      WebPanel23.Height := 500;
      WebPanel24.Height := 500;
      WebPanel25.Height := 500;
      //WebPanel1.Caption := screenWidth.ToString + ' ' + WebPanel1.Width.ToString + ' ' + WebPanel1.Height.ToString ;
     // WebImageSlider1.Width :=screenWidth -50 ;
     // WebImageSlider2.Width :=screenWidth - 50 ;
      //WebResponsiveGridPanel2.Height := 100;
      //WebPanel1.Caption := 'H 1720 Smartphone' + Form2.Width.ToString;// clientWidth.ToString();
      //WebResponsiveGridPanel1.Width := Form2.Width;
    end;
  1:
    begin
      WPCMain.ShowTabs := true;
      WPTopMenus.Visible := true;
      WebImageHamburgerLeft.Visible := false;
      WebPanel1.Height := 300;
      WebPanel2.Height := 300;
      WebPanel3.Height := 300;
      WebPanel4.Height := 300;
      WebPanel5.Height := 300;
      WebPanel6.Height := 300;
      WebPanel7.Height := 300;
      WebPanel8.Height := 300;
      // WebPamels on second Tab
      WebPanel9.Height := 500;
      WebPanel11.Height := 500;
      WebPanel12.Height := 500;
      WebPanel13.Height := 500;
      WebPanel14.Height := 500;
      WebPanel15.Height := 500;
      WebPanel16.Height := 500;
      WebPanel17.Height := 500;

      // WebPamels on third Tab
      WebPanel18.Height := 500;
      WebPanel19.Height := 500;
      WebPanel20.Height := 500;
      WebPanel21.Height := 500;
      WebPanel22.Height := 500;
      WebPanel23.Height := 500;
      WebPanel24.Height := 500;
      WebPanel25.Height := 500;
      //WebPanel2.Caption := screenWidth.ToString + ' ' + WebPanel2.Width.ToString  + ' ' + WebPanel2.Height.ToString ;
     // WebImageSlider1.Width :=screenWidth div 2 ;
     // WebImageSlider2.Width :=screenWidth div 2 ;
      //WebResponsiveGridPanel2.Height := 200;
      //WebPanel1.Caption := 'H 820 small'+ clientWidth.ToString();
    end;
  2:
    begin
      //WebResponsiveGridPanel2.Height := 620;
      //WebResponsiveGridPanel2.Height := 300;
      //WebPanel1.Caption := 'H 620 med'+ clientWidth.ToString();
    end;
//  3:
//    begin
//      WebResponsiveGridPanel1.Height := 320;
//      WebPanel1.Caption := 'H 320 large'+ clientWidth.ToString();
//    end;
end;
end;

procedure TForm1.AddSlidingAnimationsCSS;
var
  StyleElement: TJSHTMLElement;
begin
  StyleElement := TJSHTMLElement(document.createElement('style'));
  StyleElement.setAttribute('type', 'text/css');
  StyleElement.innerHTML := '.sliding-panel { animation: 1.5s ease-out 0s 1 slideInFromLeft; } ' +
                            '@keyframes slideInFromLeft { 0% { transform: translateX(-100%); } 100% { transform: translateX(0); } } ' +
                            '.sliding-panel2 { animation: 1.5s ease-out 0s 1 slideInFromRight; } ' +
                            '@keyframes slideInFromRight { 0% { transform: translateX(100%); } 100% { transform: translateX(0); } }';
  document.getElementsByTagName('head')[0].appendChild(StyleElement);
end;

procedure TForm1.UpdateTextSizes;
var
  ContainerWidth, HeaderFontSize, MainTextFontSize, SmallTextFontSize: Integer;
  HeaderElements, MainTextElements, SmallTextElements: TJSNodeList;
  I: Integer;
begin
  ContainerWidth := WebPanel3.Width;

  // Example proportional calculations
  HeaderFontSize := Max(15, ContainerWidth div 10);
  MainTextFontSize := Max(14, ContainerWidth div 25);
  SmallTextFontSize := Max(12, ContainerWidth div 30);

  // Getting the elements
  HeaderElements := TJSNodeList(document.querySelectorAll('.header-text'));
  MainTextElements := TJSNodeList(document.querySelectorAll('.main-text'));
  SmallTextElements := TJSNodeList(document.querySelectorAll('.small-text'));

  // Setting font sizes for each header element
  for I := 0 to HeaderElements.length - 1 do
    TJSHTMLElement(HeaderElements.item(I)).style.setProperty('font-size', IntToStr(HeaderFontSize) + 'px');

  // Setting font sizes for each main text element
  for I := 0 to MainTextElements.length - 1 do
    TJSHTMLElement(MainTextElements.item(I)).style.setProperty('font-size', IntToStr(MainTextFontSize) + 'px');

  // Setting font sizes for each small text element
  for I := 0 to SmallTextElements.length - 1 do
    TJSHTMLElement(SmallTextElements.item(I)).style.setProperty('font-size', IntToStr(SmallTextFontSize) + 'px');
end;

procedure TForm1.ApplySlidingAnimation(const Panel: TPanel; const AnimationType: string);
var
  PanelElement: TJSHTMLElement;
  AnimationClass: string;
begin
  // Determine the appropriate CSS class based on the animation type
  if AnimationType = 'slideInFromLeft' then
    AnimationClass := 'sliding-panel'
  else if AnimationType = 'slideInFromRight' then
    AnimationClass := 'sliding-panel2'
  else
    raise Exception.Create('Unsupported animation type');

  // Access the panel element using its ElementID
  PanelElement := TJSHTMLElement(document.getElementById(Panel.ElementID));

  // Apply the animation class to the panel
  if Assigned(PanelElement) then
    PanelElement.classList.add(AnimationClass);
end;

procedure TForm1.SetElementIDs;
var
  i: Integer;
  Component: TComponent;
begin
  for i := 0 to ComponentCount - 1 do
  begin
    Component := Components[i];
    // Exclude TWebTabControl, TWebRadioGroup, or other complex controls
    if (Component is TControl) and not (Component is TPageControl) and not (Component is TRadioGroup) then TControl(Component).ElementID := Component.Name;
  end;
end;


//procedure TForm1.DisplayEasingAnimations;
//begin
//  asm
//    var demoContentEl = document.getElementById('WebHTMLDiv1'); // Make sure this matches the ID in the HTML
//    var fragment = document.createDocumentFragment();
//    var easingNames = [
//      'easeInQuad', 'easeInCubic', 'easeInQuart', 'easeInQuint', 'easeInSine',
//      'easeInExpo', 'easeInCirc', 'easeInBack', 'easeOutQuad', 'easeOutCubic',
//      'easeOutQuart', 'easeOutQuint', 'easeOutSine', 'easeOutExpo', 'easeOutCirc',
//      'easeOutBack', 'easeInBounce', 'easeInOutQuad', 'easeInOutCubic', 'easeInOutQuart',
//      'easeInOutQuint', 'easeInOutSine', 'easeInOutExpo', 'easeInOutCirc', 'easeInOutBack',
//      'easeInOutBounce', 'easeOutBounce', 'easeOutInQuad', 'easeOutInCubic', 'easeOutInQuart',
//      'easeOutInQuint', 'easeOutInSine', 'easeOutInExpo', 'easeOutInCirc', 'easeOutInBack',
//      'easeOutInBounce'
//    ];
//
//function createEasingDemo(easing) {
//  var demoEl = document.createElement('div');
//  demoEl.classList.add('el', 'square', 'stretched', 'easing-' + easing);
//  demoEl.style.width = '15px';
//  demoEl.style.height = '5px';
//  demoEl.style.background = 'blue';
//  demoEl.style.position = 'absolute'; // Ensure it's positioned absolutely within its relative container
//  demoEl.style.left = '50%';          // Center horizontally, adjust as necessary
//  demoEl.style.transform = 'translateX(-50%)'; // Center horizontally, adjust as necessary
//  anime({
//    targets: demoEl,
//    translateY: [50, -50],
//    direction: 'alternate',
//    loop: true,
//    delay: 100,
//    endDelay: 100,
//    duration: 1000,
//    easing: easing
//  });
//  fragment.appendChild(demoEl);
//}
//
//    easingNames.forEach(function(easeName) {
//      createEasingDemo(easeName);
//    });
//
//    demoContentEl.innerHTML = ''; // Clear any existing content
//    demoContentEl.appendChild(fragment); // Append the new content
//  end;
//end;

procedure TForm1.DisplayEasingAnimations;
begin
  asm
    var container = document.getElementById('WebPanel8');
    var fragment = document.createDocumentFragment();
    var numberOfElements = 30; // Adjust the number of elements as needed

    function createVerticalAnimation() {
      var demoEl = document.createElement('div');
      demoEl.style.width = '5px'; // Element width
      demoEl.style.height = '5px'; // Element height
      demoEl.style.background = '#494A4A'; // Element color
      demoEl.style.position = 'absolute';
      demoEl.style.top = '0'; // Start from the top of the div

      var randomX = Math.random() * (container.offsetWidth - parseInt(demoEl.style.width)); // Random horizontal position within the container
      demoEl.style.left = randomX + 'px';

      var randomDelay = Math.random() * 1000; // Random delay between 0 and 1000 milliseconds
      var randomDuration = 1000 + Math.random() * 2000; // Random duration between 1000 and 3000 milliseconds

      anime({
        targets: demoEl,
        translateY: [0, container.offsetHeight - parseInt(demoEl.style.height)], // Move from top to bottom
        loop: true,
        delay: randomDelay,
        duration: randomDuration,
        easing: 'easeInOutSine'
      });

      fragment.appendChild(demoEl);
    }

    for (var i = 0; i < numberOfElements; i++) {
      createVerticalAnimation();
    }

    //container.innerHTML = ''; // Clear any existing content
    container.appendChild(fragment); // Append the new content
  end;
end;




procedure TForm1.ToggleWPLeftMenu;
var
  targetWidth: String;
begin
  // Convert the width to a string and append 'px' for CSS usage
  targetWidth := IntToStr(Form1.Width) + 'px';

  asm
    var element = document.getElementById('WPLeftMenu');
    if (!element) {
      console.error('Element WPLeftMenu not found');
      return;
    }

    var isVisible = window.getComputedStyle(element).display !== 'none' && parseInt(element.style.width) > 0;

    if (isVisible) {
      // Collapse the menu
      anime({
        targets: element.style,
        width: '0px',
        easing: 'easeInOutQuad',
        duration: 1000,
        complete: function() {
          element.style.display = 'none'; // Optionally hide element after animation
        }
      });
    } else {
      // Ensure the element is visible
      element.style.display = 'block';
      element.style.width = '0px'; // Reset width to 0px before expanding

      // Expand the menu
      anime({
        targets: element.style,
        width: targetWidth, // Use @ to pass the Delphi variable to JavaScript
        easing: 'easeInOutQuad',
        duration: 1000
      });
    }
  end;
end;

















procedure TForm1.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel10 := TPanel.Create(Self);
  WebImageHamburgerLeft := TImageControl.Create(Self);
  WebImageLogo := TImageControl.Create(Self);
  WebImageHamburgerRight := TImageControl.Create(Self);
  WPTopMenus := TPanel.Create(Self);
  WebHTMLContainer9 := THTMLContainer.Create(Self);
  WebButton2 := TButton.Create(Self);
  WPCMain := TPageControl.Create(Self);
  WebPageControlHome := TTabSheet.Create(Self);
  WRGMain := TResponsiveGridPanel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebHTMLContainer1 := THTMLContainer.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebHTMLContainer2 := THTMLContainer.Create(Self);
  WebPanel4 := TPanel.Create('webPanel4');
  WebYoutube2 := TYoutube.Create(Self);
  WebPanel5 := TPanel.Create(Self);
  WebHTMLContainer3 := THTMLContainer.Create(Self);
  WebPanel6 := TPanel.Create(Self);
  WebHTMLContainer5 := THTMLContainer.Create(Self);
  WebPanel7 := TPanel.Create(Self);
  WebHTMLContainer6 := THTMLContainer.Create(Self);
  WebPanel8 := TPanel.Create(Self);
  WebButton3 := TButton.Create(Self);
  WebPanel9 := TPanel.Create('WebPanel9');
  WebImageControl1 := TImageControl.Create(Self);
  WebPageControlSheetOther := TTabSheet.Create(Self);
  WebResponsiveGridPanel1 := TResponsiveGridPanel.Create(Self);
  WebPanel11 := TPanel.Create(Self);
  WebBrowserControl1 := TBrowserControl.Create(Self);
  WebPanel12 := TPanel.Create(Self);
  WebBrowserControl2 := TBrowserControl.Create(Self);
  WebPanel13 := TPanel.Create(Self);
  WebPanel14 := TPanel.Create(Self);
  WebPanel15 := TPanel.Create(Self);
  WebPanel16 := TPanel.Create(Self);
  WebPanel17 := TPanel.Create(Self);
  WebPanel18 := TPanel.Create(Self);
  WebResponsiveGridPanel3 := TResponsiveGridPanel.Create(Self);
  WebPanel26 := TPanel.Create(Self);
  WebHTMLContainer4 := THTMLContainer.Create(Self);
  WebPanel27 := TPanel.Create(Self);
  WebHTMLContainer20 := THTMLContainer.Create(Self);
  WebPanel28 := TPanel.Create(Self);
  WebHTMLContainer26 := THTMLContainer.Create(Self);
  WebPanel29 := TPanel.Create(Self);
  WebHTMLContainer27 := THTMLContainer.Create(Self);
  WebPanel30 := TPanel.Create(Self);
  WebHTMLContainer28 := THTMLContainer.Create(Self);
  WebPanel31 := TPanel.Create(Self);
  WebHTMLContainer29 := THTMLContainer.Create(Self);
  WebPanel32 := TPanel.Create(Self);
  WebHTMLContainer30 := THTMLContainer.Create(Self);
  WebPanel33 := TPanel.Create(Self);
  WebHTMLContainer31 := THTMLContainer.Create(Self);
  WebPageControlSheetLessons := TTabSheet.Create(Self);
  WebResponsiveGridPanel2 := TResponsiveGridPanel.Create(Self);
  WebPanel19 := TPanel.Create(Self);
  WebBrowserControl5 := TBrowserControl.Create(Self);
  WebPanel20 := TPanel.Create(Self);
  WebBrowserControl8 := TBrowserControl.Create(Self);
  WebPanel21 := TPanel.Create('WebPanel21');
  WebHTMLContainer12 := THTMLContainer.Create(Self);
  WebPanel22 := TPanel.Create(Self);
  WebHTMLContainer13 := THTMLContainer.Create(Self);
  WebPanel23 := TPanel.Create(Self);
  WebHTMLContainer7 := THTMLContainer.Create(Self);
  WebPanel24 := TPanel.Create(Self);
  WebHTMLContainer8 := THTMLContainer.Create(Self);
  WebPanel25 := TPanel.Create(Self);
  WebHTMLContainer10 := THTMLContainer.Create(Self);
  WebPanel34 := TPanel.Create(Self);
  WebHTMLContainer11 := THTMLContainer.Create(Self);
  WPCMainSheetLogin := TTabSheet.Create(Self);
  WebPanel35 := TPanel.Create(Self);
  WebPageControlLogin := TPageControl.Create(Self);
  WebPageControl1Sheet1 := TTabSheet.Create(Self);
  WebPanelLogin := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebEditLoginEmail := TEdit.Create(Self);
  WebEditLoginPassword := TEdit.Create(Self);
  WebButtonLogin := TButton.Create(Self);
  WebPageControl1Sheet2 := TTabSheet.Create(Self);
  WebPanelRegister := TPanel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebEditRegisterEmail := TEdit.Create(Self);
  WebEditRegisterMobile := TEdit.Create(Self);
  WebEditRegisterPassword := TEdit.Create(Self);
  WebEditRegisterfirstName := TEdit.Create(Self);
  WebEditRegisterSurname := TEdit.Create(Self);
  WebButtonRegister := TButton.Create(Self);
  WebButton1 := TButton.Create(Self);
  WPCMainSheet5 := TTabSheet.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  WebRadioGroup1 := TRadioGroup.Create(Self);
  WPLeftMenu := TPanel.Create(Self);
  WebLinkLabel1 := TLinkLabel.Create(Self);
  WebLinkLabel2 := TLinkLabel.Create(Self);
  WebLinkLabel3 := TLinkLabel.Create(Self);
  WebLinkLabel4 := TLinkLabel.Create(Self);
  WebLinkLabel5 := TLinkLabel.Create(Self);
  WebHttpRequestRegister := THttpRequest.Create(Self);

  WebPanel10.BeforeLoadDFMValues;
  WebImageHamburgerLeft.BeforeLoadDFMValues;
  WebImageLogo.BeforeLoadDFMValues;
  WebImageHamburgerRight.BeforeLoadDFMValues;
  WPTopMenus.BeforeLoadDFMValues;
  WebHTMLContainer9.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WPCMain.BeforeLoadDFMValues;
  WebPageControlHome.BeforeLoadDFMValues;
  WRGMain.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebHTMLContainer1.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebHTMLContainer2.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  WebYoutube2.BeforeLoadDFMValues;
  WebPanel5.BeforeLoadDFMValues;
  WebHTMLContainer3.BeforeLoadDFMValues;
  WebPanel6.BeforeLoadDFMValues;
  WebHTMLContainer5.BeforeLoadDFMValues;
  WebPanel7.BeforeLoadDFMValues;
  WebHTMLContainer6.BeforeLoadDFMValues;
  WebPanel8.BeforeLoadDFMValues;
  WebButton3.BeforeLoadDFMValues;
  WebPanel9.BeforeLoadDFMValues;
  WebImageControl1.BeforeLoadDFMValues;
  WebPageControlSheetOther.BeforeLoadDFMValues;
  WebResponsiveGridPanel1.BeforeLoadDFMValues;
  WebPanel11.BeforeLoadDFMValues;
  WebBrowserControl1.BeforeLoadDFMValues;
  WebPanel12.BeforeLoadDFMValues;
  WebBrowserControl2.BeforeLoadDFMValues;
  WebPanel13.BeforeLoadDFMValues;
  WebPanel14.BeforeLoadDFMValues;
  WebPanel15.BeforeLoadDFMValues;
  WebPanel16.BeforeLoadDFMValues;
  WebPanel17.BeforeLoadDFMValues;
  WebPanel18.BeforeLoadDFMValues;
  WebResponsiveGridPanel3.BeforeLoadDFMValues;
  WebPanel26.BeforeLoadDFMValues;
  WebHTMLContainer4.BeforeLoadDFMValues;
  WebPanel27.BeforeLoadDFMValues;
  WebHTMLContainer20.BeforeLoadDFMValues;
  WebPanel28.BeforeLoadDFMValues;
  WebHTMLContainer26.BeforeLoadDFMValues;
  WebPanel29.BeforeLoadDFMValues;
  WebHTMLContainer27.BeforeLoadDFMValues;
  WebPanel30.BeforeLoadDFMValues;
  WebHTMLContainer28.BeforeLoadDFMValues;
  WebPanel31.BeforeLoadDFMValues;
  WebHTMLContainer29.BeforeLoadDFMValues;
  WebPanel32.BeforeLoadDFMValues;
  WebHTMLContainer30.BeforeLoadDFMValues;
  WebPanel33.BeforeLoadDFMValues;
  WebHTMLContainer31.BeforeLoadDFMValues;
  WebPageControlSheetLessons.BeforeLoadDFMValues;
  WebResponsiveGridPanel2.BeforeLoadDFMValues;
  WebPanel19.BeforeLoadDFMValues;
  WebBrowserControl5.BeforeLoadDFMValues;
  WebPanel20.BeforeLoadDFMValues;
  WebBrowserControl8.BeforeLoadDFMValues;
  WebPanel21.BeforeLoadDFMValues;
  WebHTMLContainer12.BeforeLoadDFMValues;
  WebPanel22.BeforeLoadDFMValues;
  WebHTMLContainer13.BeforeLoadDFMValues;
  WebPanel23.BeforeLoadDFMValues;
  WebHTMLContainer7.BeforeLoadDFMValues;
  WebPanel24.BeforeLoadDFMValues;
  WebHTMLContainer8.BeforeLoadDFMValues;
  WebPanel25.BeforeLoadDFMValues;
  WebHTMLContainer10.BeforeLoadDFMValues;
  WebPanel34.BeforeLoadDFMValues;
  WebHTMLContainer11.BeforeLoadDFMValues;
  WPCMainSheetLogin.BeforeLoadDFMValues;
  WebPanel35.BeforeLoadDFMValues;
  WebPageControlLogin.BeforeLoadDFMValues;
  WebPageControl1Sheet1.BeforeLoadDFMValues;
  WebPanelLogin.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebEditLoginEmail.BeforeLoadDFMValues;
  WebEditLoginPassword.BeforeLoadDFMValues;
  WebButtonLogin.BeforeLoadDFMValues;
  WebPageControl1Sheet2.BeforeLoadDFMValues;
  WebPanelRegister.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebEditRegisterEmail.BeforeLoadDFMValues;
  WebEditRegisterMobile.BeforeLoadDFMValues;
  WebEditRegisterPassword.BeforeLoadDFMValues;
  WebEditRegisterfirstName.BeforeLoadDFMValues;
  WebEditRegisterSurname.BeforeLoadDFMValues;
  WebButtonRegister.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WPCMainSheet5.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  WebRadioGroup1.BeforeLoadDFMValues;
  WPLeftMenu.BeforeLoadDFMValues;
  WebLinkLabel1.BeforeLoadDFMValues;
  WebLinkLabel2.BeforeLoadDFMValues;
  WebLinkLabel3.BeforeLoadDFMValues;
  WebLinkLabel4.BeforeLoadDFMValues;
  WebLinkLabel5.BeforeLoadDFMValues;
  WebHttpRequestRegister.BeforeLoadDFMValues;
  try
    Name := 'Form1';
    Width := 958;
    Height := 2000;
    CSSLibrary := cssBootstrap;
    ElementClassName := 'body';
    ElementFont := efCSS;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel10.SetParentComponent(Self);
    WebPanel10.Name := 'WebPanel10';
    WebPanel10.Left := 0;
    WebPanel10.Top := 0;
    WebPanel10.Width := 958;
    WebPanel10.Height := 73;
    WebPanel10.ElementClassName := 'card';
    WebPanel10.Align := alTop;
    WebPanel10.BorderColor := clBlack;
    WebPanel10.BorderStyle := bsNone;
    WebPanel10.ChildOrder := 3;
    WebPanel10.Color := clWindow;
    WebPanel10.ElementBodyClassName := 'card-body';
    WebPanel10.ElementFont := efCSS;
    WebPanel10.TabOrder := 0;
    WebImageHamburgerLeft.SetParentComponent(WebPanel10);
    WebImageHamburgerLeft.Name := 'WebImageHamburgerLeft';
    WebImageHamburgerLeft.AlignWithMargins := True;
    WebImageHamburgerLeft.Left := 3;
    WebImageHamburgerLeft.Top := 0;
    WebImageHamburgerLeft.Width := 41;
    WebImageHamburgerLeft.Height := 60;
    WebImageHamburgerLeft.Margins.Left := 10;
    WebImageHamburgerLeft.Margins.Top := 10;
    WebImageHamburgerLeft.Margins.Right := 10;
    WebImageHamburgerLeft.Margins.Bottom := 10;
    WebImageHamburgerLeft.HeightPercent := 100.000000000000000000;
    WebImageHamburgerLeft.WidthPercent := 100.000000000000000000;
    SetEvent(WebImageHamburgerLeft, Self, 'OnClick', 'WebImageHamburgerLeftClick');
    WebImageHamburgerLeft.Picture.LoadFromFile('Unit1.WebPanel10.WebImageHamburgerLeft.Picture.png');
    WebImageLogo.SetParentComponent(WebPanel10);
    WebImageLogo.Name := 'WebImageLogo';
    WebImageLogo.AlignWithMargins := True;
    WebImageLogo.Left := 47;
    WebImageLogo.Top := 0;
    WebImageLogo.Width := 216;
    WebImageLogo.Height := 60;
    WebImageLogo.HeightPercent := 100.000000000000000000;
    WebImageLogo.WidthPercent := 100.000000000000000000;
    WebImageLogo.ChildOrder := 1;
    WebImageLogo.Picture.LoadFromFile('Unit1.WebPanel10.WebImageLogo.Picture.png');
    WebImageHamburgerRight.SetParentComponent(WebPanel10);
    WebImageHamburgerRight.Name := 'WebImageHamburgerRight';
    WebImageHamburgerRight.AlignWithMargins := True;
    WebImageHamburgerRight.Left := 907;
    WebImageHamburgerRight.Top := 10;
    WebImageHamburgerRight.Width := 41;
    WebImageHamburgerRight.Height := 53;
    WebImageHamburgerRight.Margins.Left := 10;
    WebImageHamburgerRight.Margins.Top := 10;
    WebImageHamburgerRight.Margins.Right := 10;
    WebImageHamburgerRight.Margins.Bottom := 10;
    WebImageHamburgerRight.HeightPercent := 100.000000000000000000;
    WebImageHamburgerRight.WidthPercent := 100.000000000000000000;
    WebImageHamburgerRight.Align := alRight;
    WebImageHamburgerRight.ChildOrder := 3;
    WebImageHamburgerRight.Visible := False;
    WebImageHamburgerRight.Picture.LoadFromFile('Unit1.WebPanel10.WebImageHamburgerRight.Picture.png');
    WPTopMenus.SetParentComponent(WebPanel10);
    WPTopMenus.Name := 'WPTopMenus';
    WPTopMenus.Left := 199;
    WPTopMenus.Top := 0;
    WPTopMenus.Width := 698;
    WPTopMenus.Height := 73;
    WPTopMenus.ElementClassName := 'main-text';
    WPTopMenus.HeightStyle := ssPercent;
    WPTopMenus.Align := alRight;
    WPTopMenus.BorderStyle := bsNone;
    WPTopMenus.ChildOrder := 3;
    WPTopMenus.Color := clWindow;
    WPTopMenus.ElementBodyClassName := 'main-text';
    WPTopMenus.ElementFont := efCSS;
    WPTopMenus.TabOrder := 0;
    WebHTMLContainer9.SetParentComponent(WPTopMenus);
    WebHTMLContainer9.Name := 'WebHTMLContainer9';
    WebHTMLContainer9.Left := 0;
    WebHTMLContainer9.Top := 0;
    WebHTMLContainer9.Width := 698;
    WebHTMLContainer9.Height := 73;
    WebHTMLContainer9.Margins.Left := 20;
    WebHTMLContainer9.Margins.Top := 20;
    WebHTMLContainer9.Margins.Right := 20;
    WebHTMLContainer9.Margins.Bottom := 20;
    WebHTMLContainer9.Align := alClient;
    WebHTMLContainer9.ChildOrder := 1;
    WebHTMLContainer9.ElementFont := efCSS;
    WebHTMLContainer9.Font.Charset := DEFAULT_CHARSET;
    WebHTMLContainer9.Font.Color := clWhite;
    WebHTMLContainer9.Font.Height := -15;
    WebHTMLContainer9.Font.Name := 'Segoe UI';
    WebHTMLContainer9.Font.Style := [];
    WebHTMLContainer9.HTML.BeginUpdate;
    try
      WebHTMLContainer9.HTML.Clear;
      WebHTMLContainer9.HTML.Add('<p style="font-size: calc(min(14px, 18px + 2vw));text-align: center"><FONT color="#FFFFFF">AI-Powered Safety: Securing Tomorrow'#39's Workplaces ');
      WebHTMLContainer9.HTML.Add('Today</FONT></p>');
    finally
      WebHTMLContainer9.HTML.EndUpdate;
    end;
    WebButton2.SetParentComponent(WPTopMenus);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 304;
    WebButton2.Top := 24;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'WebButton2';
    WebButton2.ChildOrder := 1;
    WebButton2.ElementClassName := 'btn btn-light';
    WebButton2.ElementFont := efCSS;
    WebButton2.HeightStyle := ssAuto;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WPCMain.SetParentComponent(Self);
    WPCMain.Name := 'WPCMain';
    WPCMain.AlignWithMargins := True;
    WPCMain.Left := 153;
    WPCMain.Top := 98;
    WPCMain.Width := 802;
    WPCMain.Height := 1899;
    WPCMain.Margins.Top := 25;
    WPCMain.ElementClassName := 'nav nav-tabs';
    WPCMain.Align := alClient;
    WPCMain.ChildOrder := 4;
    WPCMain.ElementTabClassName := 'nav-link';
    WPCMain.ElementTabActiveClassName := 'nav-link active';
    WPCMain.ElementTabItemClassName := 'nav-item';
    WPCMain.ElementFont := efCSS;
    WPCMain.Font.Charset := DEFAULT_CHARSET;
    WPCMain.Font.Color := clWindow;
    WPCMain.Font.Height := -15;
    WPCMain.Font.Name := 'Segoe UI';
    WPCMain.Font.Style := [];
    WPCMain.TabIndex := 4;
    WPCMain.ParentFont := False;
    WPCMain.SelectedColor := clInactiveCaption;
    WPCMain.TabOrder := 1;
    WebPageControlHome.SetParentComponent(WPCMain);
    WebPageControlHome.Name := 'WebPageControlHome';
    WebPageControlHome.Left := 0;
    WebPageControlHome.Top := 20;
    WebPageControlHome.Width := 802;
    WebPageControlHome.Height := 1879;
    WebPageControlHome.Caption := 'Home Page';
    WebPageControlHome.ChildOrder := 3;
    WebPageControlHome.Color := clNone;
    WebPageControlHome.ElementFont := efCSS;
    WebPageControlHome.Font.Charset := DEFAULT_CHARSET;
    WebPageControlHome.Font.Color := clWhite;
    WebPageControlHome.Font.Height := -42;
    WebPageControlHome.Font.Name := 'Segoe UI';
    WebPageControlHome.Font.Style := [];
    WebPageControlHome.ParentFont := False;
    WRGMain.SetParentComponent(WebPageControlHome);
    WRGMain.Name := 'WRGMain';
    WRGMain.Left := 0;
    WRGMain.Top := 0;
    WRGMain.Width := 802;
    WRGMain.Height := 1879;
    WRGMain.Margins.Left := 50;
    WRGMain.Margins.Top := 50;
    WRGMain.Margins.Right := 50;
    WRGMain.Margins.Bottom := 50;
    WRGMain.HeightStyle := ssAuto;
    WRGMain.Align := alClient;
    WRGMain.ControlCollection.Clear;
    with WRGMain.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebPanel2;
    end;
    with WRGMain.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel3;
    end;
    with WRGMain.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel4;
    end;
    with WRGMain.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel5;
    end;
    with WRGMain.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel6;
    end;
    with WRGMain.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel7;
    end;
    with WRGMain.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel8;
    end;
    with WRGMain.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel9;
    end;
    WRGMain.Color := clNone;
    WRGMain.ElementFont := efCSS;
    WRGMain.Layout.Clear;
    with WRGMain.Layout.Add do
    begin
      Description := 'Smartphone';
      Style := '1fr';
      Width := 450;
    end;
    with WRGMain.Layout.Add do
    begin
      Description := 'Tablet';
      Style := '1fr 1fr';
      Width := 750;
    end;
    SetEvent(WRGMain, Self, 'OnLayoutChange', 'WRGMainLayoutChange');
    WebPanel2.SetParentComponent(WRGMain);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.AlignWithMargins := True;
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 401;
    WebPanel2.Height := 60;
    WebPanel2.Margins.Left := 15;
    WebPanel2.Margins.Top := 15;
    WebPanel2.Margins.Right := 15;
    WebPanel2.Margins.Bottom := 15;
    WebPanel2.ElementClassName := 'web-panel';
    WebPanel2.WidthStyle := ssPercent;
    WebPanel2.Anchors := [];
    WebPanel2.BorderStyle := bsNone;
    WebPanel2.Color := clWindow;
    WebPanel2.ElementBodyClassName := 'card-body';
    WebPanel2.ElementFont := efCSS;
    WebPanel2.TabOrder := 0;
    WebHTMLContainer1.SetParentComponent(WebPanel2);
    WebHTMLContainer1.Name := 'WebHTMLContainer1';
    WebHTMLContainer1.AlignWithMargins := True;
    WebHTMLContainer1.Left := 15;
    WebHTMLContainer1.Top := 15;
    WebHTMLContainer1.Width := 371;
    WebHTMLContainer1.Height := 30;
    WebHTMLContainer1.Margins.Left := 15;
    WebHTMLContainer1.Margins.Top := 15;
    WebHTMLContainer1.Margins.Right := 15;
    WebHTMLContainer1.Margins.Bottom := 15;
    WebHTMLContainer1.Align := alClient;
    WebHTMLContainer1.ChildOrder := 1;
    WebHTMLContainer1.ElementFont := efCSS;
    WebHTMLContainer1.Font.Charset := DEFAULT_CHARSET;
    WebHTMLContainer1.Font.Color := clBackground;
    WebHTMLContainer1.Font.Height := -15;
    WebHTMLContainer1.Font.Name := 'Segoe UI';
    WebHTMLContainer1.Font.Style := [];
    WebHTMLContainer1.HTML.BeginUpdate;
    try
      WebHTMLContainer1.HTML.Clear;
      WebHTMLContainer1.HTML.Add('<p style="font-size: calc(min(30px, 18px + 2vw)); font-weight: bold; text-align: center;">WELCOME TO OUR STORY</p>');
      WebHTMLContainer1.HTML.Add('<p style="font-size: calc(min(14px, 18px + 2vw));;text-align: center">AI Solutions to your HSE problems</p>');
      WebHTMLContainer1.HTML.Add('');
      WebHTMLContainer1.HTML.Add('');
    finally
      WebHTMLContainer1.HTML.EndUpdate;
    end;
    WebPanel3.SetParentComponent(WRGMain);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 401;
    WebPanel3.Top := 0;
    WebPanel3.Width := 401;
    WebPanel3.Height := 60;
    WebPanel3.ElementClassName := 'web-panel';
    WebPanel3.WidthStyle := ssPercent;
    WebPanel3.Anchors := [];
    WebPanel3.BorderStyle := bsNone;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clWindow;
    WebPanel3.ElementBodyClassName := 'card-body';
    WebPanel3.ElementFont := efCSS;
    WebPanel3.TabOrder := 1;
    WebHTMLContainer2.SetParentComponent(WebPanel3);
    WebHTMLContainer2.Name := 'WebHTMLContainer2';
    WebHTMLContainer2.AlignWithMargins := True;
    WebHTMLContainer2.Left := 15;
    WebHTMLContainer2.Top := 15;
    WebHTMLContainer2.Width := 371;
    WebHTMLContainer2.Height := 30;
    WebHTMLContainer2.Margins.Left := 15;
    WebHTMLContainer2.Margins.Top := 15;
    WebHTMLContainer2.Margins.Right := 15;
    WebHTMLContainer2.Margins.Bottom := 15;
    WebHTMLContainer2.Align := alClient;
    WebHTMLContainer2.ChildOrder := 1;
    WebHTMLContainer2.ElementFont := efCSS;
    WebHTMLContainer2.Font.Charset := DEFAULT_CHARSET;
    WebHTMLContainer2.Font.Color := clBackground;
    WebHTMLContainer2.Font.Height := -15;
    WebHTMLContainer2.Font.Name := 'Segoe UI';
    WebHTMLContainer2.Font.Style := [];
    WebHTMLContainer2.HTML.BeginUpdate;
    try
      WebHTMLContainer2.HTML.Clear;
      WebHTMLContainer2.HTML.Add('<p style="font-size: calc(min(18px, 18px + 2vw));;text-align: center">Empowering safer workplaces through cutting-edge AI solutions.<BR>Our mission is ');
      WebHTMLContainer2.HTML.Add('to ');
      WebHTMLContainer2.HTML.Add('revolutionize health and safety practices by leveraging artificial intelligence to predict, prevent, and protect against potential hazards.<BR>By harnessing ');
      WebHTMLContainer2.HTML.Add('the ');
      WebHTMLContainer2.HTML.Add('power of AI, we strive to ensure the well-being of every individual within the workplace, fostering a culture of safety and security.</p>');
    finally
      WebHTMLContainer2.HTML.EndUpdate;
    end;
    WebPanel4.SetParentComponent(WRGMain);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 0;
    WebPanel4.Top := 60;
    WebPanel4.Width := 401;
    WebPanel4.Height := 60;
    WebPanel4.ElementClassName := 'web-panel';
    WebPanel4.WidthStyle := ssPercent;
    WebPanel4.Anchors := [];
    WebPanel4.BorderStyle := bsNone;
    WebPanel4.ChildOrder := 2;
    WebPanel4.Color := clWindow;
    WebPanel4.ElementBodyClassName := 'card-body';
    WebPanel4.ElementFont := efCSS;
    WebPanel4.TabOrder := 2;
    WebYoutube2.SetParentComponent(WebPanel4);
    WebYoutube2.Name := 'WebYoutube2';
    WebYoutube2.AlignWithMargins := True;
    WebYoutube2.Left := 15;
    WebYoutube2.Top := 15;
    WebYoutube2.Width := 371;
    WebYoutube2.Height := 30;
    WebYoutube2.Margins.Left := 15;
    WebYoutube2.Margins.Top := 15;
    WebYoutube2.Margins.Right := 15;
    WebYoutube2.Margins.Bottom := 15;
    WebYoutube2.Align := alClient;
    WebYoutube2.AllowFullScreen := False;
    WebYoutube2.AutoPlay := False;
    WebYoutube2.VideoID := '5KUy-UHa2Zc';
    WebPanel5.SetParentComponent(WRGMain);
    WebPanel5.Name := 'WebPanel5';
    WebPanel5.Left := 401;
    WebPanel5.Top := 60;
    WebPanel5.Width := 401;
    WebPanel5.Height := 60;
    WebPanel5.ElementClassName := 'web-panel';
    WebPanel5.WidthStyle := ssPercent;
    WebPanel5.Anchors := [];
    WebPanel5.BorderStyle := bsNone;
    WebPanel5.ChildOrder := 3;
    WebPanel5.Color := clWindow;
    WebPanel5.ElementBodyClassName := 'card-body';
    WebPanel5.ElementFont := efCSS;
    WebPanel5.TabOrder := 3;
    WebHTMLContainer3.SetParentComponent(WebPanel5);
    WebHTMLContainer3.Name := 'WebHTMLContainer3';
    WebHTMLContainer3.AlignWithMargins := True;
    WebHTMLContainer3.Left := 15;
    WebHTMLContainer3.Top := 15;
    WebHTMLContainer3.Width := 371;
    WebHTMLContainer3.Height := 30;
    WebHTMLContainer3.Margins.Left := 15;
    WebHTMLContainer3.Margins.Top := 15;
    WebHTMLContainer3.Margins.Right := 15;
    WebHTMLContainer3.Margins.Bottom := 15;
    WebHTMLContainer3.Align := alClient;
    WebHTMLContainer3.ChildOrder := 1;
    WebHTMLContainer3.ElementFont := efCSS;
    WebHTMLContainer3.Font.Charset := DEFAULT_CHARSET;
    WebHTMLContainer3.Font.Color := clNone;
    WebHTMLContainer3.Font.Height := -15;
    WebHTMLContainer3.Font.Name := 'Segoe UI';
    WebHTMLContainer3.Font.Style := [];
    WebHTMLContainer3.HTML.BeginUpdate;
    try
      WebHTMLContainer3.HTML.Clear;
      WebHTMLContainer3.HTML.Add('<p style="font-size: calc(min(30px, 18px + 2vw)); font-weight: bold; text-align: center;">HOW IS AI USED ?</p>');
      WebHTMLContainer3.HTML.Add('<p style="font-size: calc(min(14px, 18px + 2vw));;text-align: center">Through advanced data analysis and predictive modeling, AI algorithms identify ');
      WebHTMLContainer3.HTML.Add('potential risks and hazards before they occur. These algorithms can analyze vast amounts of data from various sources, including sensors, cameras, and ');
      WebHTMLContainer3.HTML.Add('employee reports, to detect patterns and trends indicative of potential safety concerns. Additionally, AI-driven solutions provide real-time monitoring ');
      WebHTMLContainer3.HTML.Add('and alerts, enabling proactive intervention to prevent accidents and ensure prompt response to emergencies. By leveraging AI, the company empowers ');
      WebHTMLContainer3.HTML.Add('organizations to create safer environments, reduce incidents, and protect the well-being of their employees.</p>');
    finally
      WebHTMLContainer3.HTML.EndUpdate;
    end;
    WebPanel6.SetParentComponent(WRGMain);
    WebPanel6.Name := 'WebPanel6';
    WebPanel6.Left := 0;
    WebPanel6.Top := 120;
    WebPanel6.Width := 401;
    WebPanel6.Height := 60;
    WebPanel6.ElementClassName := 'web-panel';
    WebPanel6.WidthStyle := ssPercent;
    WebPanel6.Anchors := [];
    WebPanel6.BorderStyle := bsNone;
    WebPanel6.ChildOrder := 4;
    WebPanel6.Color := clWindow;
    WebPanel6.ElementBodyClassName := 'card-body';
    WebPanel6.ElementFont := efCSS;
    WebPanel6.TabOrder := 4;
    WebHTMLContainer5.SetParentComponent(WebPanel6);
    WebHTMLContainer5.Name := 'WebHTMLContainer5';
    WebHTMLContainer5.AlignWithMargins := True;
    WebHTMLContainer5.Left := 15;
    WebHTMLContainer5.Top := 15;
    WebHTMLContainer5.Width := 371;
    WebHTMLContainer5.Height := 30;
    WebHTMLContainer5.Margins.Left := 15;
    WebHTMLContainer5.Margins.Top := 15;
    WebHTMLContainer5.Margins.Right := 15;
    WebHTMLContainer5.Margins.Bottom := 15;
    WebHTMLContainer5.Align := alClient;
    WebHTMLContainer5.ChildOrder := 1;
    WebHTMLContainer5.ElementFont := efCSS;
    WebHTMLContainer5.Font.Charset := DEFAULT_CHARSET;
    WebHTMLContainer5.Font.Color := clNone;
    WebHTMLContainer5.Font.Height := -15;
    WebHTMLContainer5.Font.Name := 'Segoe UI';
    WebHTMLContainer5.Font.Style := [];
    WebHTMLContainer5.HTML.BeginUpdate;
    try
      WebHTMLContainer5.HTML.Clear;
      WebHTMLContainer5.HTML.Add('<p style="font-size: calc(min(30px, 18px + 2vw)); font-weight: bold; text-align: center;">HOW IS AI USED ?</p>');
      WebHTMLContainer5.HTML.Add('<p style="font-size: calc(min(14px, 18px + 2vw));;text-align: center">Lorem ipsum dolor sit amet, consectetur ');
      WebHTMLContainer5.HTML.Add('adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco ');
      WebHTMLContainer5.HTML.Add('laboris </p>');
    finally
      WebHTMLContainer5.HTML.EndUpdate;
    end;
    WebPanel7.SetParentComponent(WRGMain);
    WebPanel7.Name := 'WebPanel7';
    WebPanel7.Left := 401;
    WebPanel7.Top := 120;
    WebPanel7.Width := 401;
    WebPanel7.Height := 60;
    WebPanel7.ElementClassName := 'web-panel';
    WebPanel7.WidthStyle := ssPercent;
    WebPanel7.Anchors := [];
    WebPanel7.BorderStyle := bsNone;
    WebPanel7.ChildOrder := 5;
    WebPanel7.Color := clWindow;
    WebPanel7.ElementBodyClassName := 'card-body';
    WebPanel7.ElementFont := efCSS;
    WebPanel7.TabOrder := 5;
    WebHTMLContainer6.SetParentComponent(WebPanel7);
    WebHTMLContainer6.Name := 'WebHTMLContainer6';
    WebHTMLContainer6.AlignWithMargins := True;
    WebHTMLContainer6.Left := 15;
    WebHTMLContainer6.Top := 15;
    WebHTMLContainer6.Width := 371;
    WebHTMLContainer6.Height := 30;
    WebHTMLContainer6.Margins.Left := 15;
    WebHTMLContainer6.Margins.Top := 15;
    WebHTMLContainer6.Margins.Right := 15;
    WebHTMLContainer6.Margins.Bottom := 15;
    WebHTMLContainer6.Align := alClient;
    WebHTMLContainer6.ChildOrder := 1;
    WebHTMLContainer6.ElementFont := efCSS;
    WebHTMLContainer6.Font.Charset := DEFAULT_CHARSET;
    WebHTMLContainer6.Font.Color := clNone;
    WebHTMLContainer6.Font.Height := -15;
    WebHTMLContainer6.Font.Name := 'Segoe UI';
    WebHTMLContainer6.Font.Style := [];
    WebHTMLContainer6.HTML.BeginUpdate;
    try
      WebHTMLContainer6.HTML.Clear;
      WebHTMLContainer6.HTML.Add('<p style="font-size: calc(min(30px, 18px + 2vw)); font-weight: bold; text-align: center;">HOW IS AI USED ?</p>');
      WebHTMLContainer6.HTML.Add('<p style="font-size: calc(min(14px, 18px + 2vw));;text-align: center">Lorem ipsum dolor sit amet, consectetur ');
      WebHTMLContainer6.HTML.Add('adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco ');
      WebHTMLContainer6.HTML.Add('laboris </p>');
    finally
      WebHTMLContainer6.HTML.EndUpdate;
    end;
    WebPanel8.SetParentComponent(WRGMain);
    WebPanel8.Name := 'WebPanel8';
    WebPanel8.Left := 0;
    WebPanel8.Top := 180;
    WebPanel8.Width := 401;
    WebPanel8.Height := 60;
    WebPanel8.ElementClassName := 'web-panel';
    WebPanel8.WidthStyle := ssPercent;
    WebPanel8.Anchors := [];
    WebPanel8.BorderStyle := bsNone;
    WebPanel8.ChildOrder := 6;
    WebPanel8.Color := clWindow;
    WebPanel8.ElementBodyClassName := 'card-body';
    WebPanel8.ElementFont := efCSS;
    WebPanel8.TabOrder := 6;
    WebButton3.SetParentComponent(WebPanel8);
    WebButton3.Name := 'WebButton3';
    WebButton3.Left := 152;
    WebButton3.Top := 16;
    WebButton3.Width := 96;
    WebButton3.Height := 25;
    WebButton3.Caption := 'WebButton3';
    WebButton3.ChildOrder := 1;
    WebButton3.ElementClassName := 'btn btn-light';
    WebButton3.ElementFont := efCSS;
    WebButton3.HeightStyle := ssAuto;
    WebButton3.HeightPercent := 100.000000000000000000;
    WebButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton3, Self, 'OnClick', 'WebButton3Click');
    WebPanel9.SetParentComponent(WRGMain);
    WebPanel9.Name := 'WebPanel9';
    WebPanel9.Left := 401;
    WebPanel9.Top := 180;
    WebPanel9.Width := 401;
    WebPanel9.Height := 60;
    WebPanel9.ElementClassName := 'web-panel';
    WebPanel9.WidthStyle := ssPercent;
    WebPanel9.Anchors := [];
    WebPanel9.BorderStyle := bsNone;
    WebPanel9.ChildOrder := 7;
    WebPanel9.Color := clWindow;
    WebPanel9.ElementBodyClassName := 'card-body';
    WebPanel9.ElementFont := efCSS;
    WebPanel9.TabOrder := 7;
    WebImageControl1.SetParentComponent(WebPanel9);
    WebImageControl1.Name := 'WebImageControl1';
    WebImageControl1.Left := 0;
    WebImageControl1.Top := 0;
    WebImageControl1.Width := 401;
    WebImageControl1.Height := 60;
    WebImageControl1.HeightPercent := 100.000000000000000000;
    WebImageControl1.WidthPercent := 100.000000000000000000;
    WebImageControl1.Align := alClient;
    WebImageControl1.Picture.LoadFromFile('Unit1.WebPanel9.WebImageControl1.Picture.png');
    WebImageControl1.URL := 'logo.svg';
    WebPageControlSheetOther.SetParentComponent(WPCMain);
    WebPageControlSheetOther.Name := 'WebPageControlSheetOther';
    WebPageControlSheetOther.Left := 0;
    WebPageControlSheetOther.Top := 20;
    WebPageControlSheetOther.Width := 802;
    WebPageControlSheetOther.Height := 1879;
    WebPageControlSheetOther.Caption := 'Lessons';
    WebPageControlSheetOther.ChildOrder := 1;
    WebPageControlSheetOther.Color := clNone;
    WebPageControlSheetOther.ElementFont := efCSS;
    WebPageControlSheetOther.Font.Charset := DEFAULT_CHARSET;
    WebPageControlSheetOther.Font.Color := clNone;
    WebPageControlSheetOther.Font.Height := -15;
    WebPageControlSheetOther.Font.Name := 'Segoe UI';
    WebPageControlSheetOther.Font.Style := [];
    WebPageControlSheetOther.ParentFont := False;
    WebResponsiveGridPanel1.SetParentComponent(WebPageControlSheetOther);
    WebResponsiveGridPanel1.Name := 'WebResponsiveGridPanel1';
    WebResponsiveGridPanel1.Left := 0;
    WebResponsiveGridPanel1.Top := 0;
    WebResponsiveGridPanel1.Width := 802;
    WebResponsiveGridPanel1.Height := 1897;
    WebResponsiveGridPanel1.Margins.Left := 50;
    WebResponsiveGridPanel1.Margins.Top := 50;
    WebResponsiveGridPanel1.Margins.Right := 50;
    WebResponsiveGridPanel1.Margins.Bottom := 50;
    WebResponsiveGridPanel1.HeightStyle := ssAuto;
    WebResponsiveGridPanel1.Align := alTop;
    WebResponsiveGridPanel1.ChildOrder := 1;
    WebResponsiveGridPanel1.ControlCollection.Clear;
    with WebResponsiveGridPanel1.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebPanel11;
    end;
    with WebResponsiveGridPanel1.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel12;
    end;
    with WebResponsiveGridPanel1.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel13;
    end;
    with WebResponsiveGridPanel1.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel14;
    end;
    with WebResponsiveGridPanel1.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel15;
    end;
    with WebResponsiveGridPanel1.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel16;
    end;
    with WebResponsiveGridPanel1.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel17;
    end;
    with WebResponsiveGridPanel1.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel18;
    end;
    WebResponsiveGridPanel1.Color := clNone;
    WebResponsiveGridPanel1.ElementFont := efCSS;
    WebResponsiveGridPanel1.Layout.Clear;
    with WebResponsiveGridPanel1.Layout.Add do
    begin
      Description := 'Smartphone';
      Style := '1fr';
      Width := 450;
    end;
    with WebResponsiveGridPanel1.Layout.Add do
    begin
      Description := 'Tablet';
      Style := '1fr 1fr';
      Width := 750;
    end;
    WebPanel11.SetParentComponent(WebResponsiveGridPanel1);
    WebPanel11.Name := 'WebPanel11';
    WebPanel11.Left := 0;
    WebPanel11.Top := 0;
    WebPanel11.Width := 401;
    WebPanel11.Height := 150;
    WebPanel11.ElementClassName := 'web-panel';
    WebPanel11.WidthStyle := ssPercent;
    WebPanel11.Anchors := [];
    WebPanel11.Color := clWindow;
    WebPanel11.ElementBodyClassName := 'card-body';
    WebPanel11.ElementFont := efCSS;
    WebPanel11.Font.Charset := DEFAULT_CHARSET;
    WebPanel11.Font.Color := clNone;
    WebPanel11.Font.Height := -15;
    WebPanel11.Font.Name := 'Segoe UI';
    WebPanel11.Font.Style := [];
    WebPanel11.ParentFont := False;
    WebPanel11.TabOrder := 0;
    WebBrowserControl1.SetParentComponent(WebPanel11);
    WebBrowserControl1.Name := 'WebBrowserControl1';
    WebBrowserControl1.AlignWithMargins := True;
    WebBrowserControl1.Left := 15;
    WebBrowserControl1.Top := 15;
    WebBrowserControl1.Width := 371;
    WebBrowserControl1.Height := 120;
    WebBrowserControl1.Margins.Left := 15;
    WebBrowserControl1.Margins.Top := 15;
    WebBrowserControl1.Margins.Right := 15;
    WebBrowserControl1.Margins.Bottom := 15;
    WebBrowserControl1.Align := alClient;
    WebBrowserControl1.Sandbox := [];
    WebBrowserControl1.URL := 'https://app.mindsmith.ai/lesson/cltrio6fb002gjw08dw5ualzj/preview';
    WebPanel12.SetParentComponent(WebResponsiveGridPanel1);
    WebPanel12.Name := 'WebPanel12';
    WebPanel12.Left := 401;
    WebPanel12.Top := 0;
    WebPanel12.Width := 401;
    WebPanel12.Height := 150;
    WebPanel12.ElementClassName := 'web-panel';
    WebPanel12.WidthStyle := ssPercent;
    WebPanel12.Anchors := [];
    WebPanel12.ChildOrder := 1;
    WebPanel12.Color := clWindow;
    WebPanel12.ElementBodyClassName := 'card-body';
    WebPanel12.ElementFont := efCSS;
    WebPanel12.Font.Charset := DEFAULT_CHARSET;
    WebPanel12.Font.Color := clNone;
    WebPanel12.Font.Height := -15;
    WebPanel12.Font.Name := 'Segoe UI';
    WebPanel12.Font.Style := [];
    WebPanel12.ParentFont := False;
    WebPanel12.TabOrder := 1;
    WebBrowserControl2.SetParentComponent(WebPanel12);
    WebBrowserControl2.Name := 'WebBrowserControl2';
    WebBrowserControl2.AlignWithMargins := True;
    WebBrowserControl2.Left := 15;
    WebBrowserControl2.Top := 15;
    WebBrowserControl2.Width := 371;
    WebBrowserControl2.Height := 120;
    WebBrowserControl2.Margins.Left := 15;
    WebBrowserControl2.Margins.Top := 15;
    WebBrowserControl2.Margins.Right := 15;
    WebBrowserControl2.Margins.Bottom := 15;
    WebBrowserControl2.Align := alClient;
    WebBrowserControl2.Sandbox := [];
    WebBrowserControl2.URL := 'https://app.mindsmith.ai/lesson/cltrf4vs50038jt08uq9hq9rn/preview';
    WebPanel13.SetParentComponent(WebResponsiveGridPanel1);
    WebPanel13.Name := 'WebPanel13';
    WebPanel13.Left := 0;
    WebPanel13.Top := 150;
    WebPanel13.Width := 401;
    WebPanel13.Height := 150;
    WebPanel13.ElementClassName := 'web-panel';
    WebPanel13.WidthStyle := ssPercent;
    WebPanel13.Anchors := [];
    WebPanel13.ChildOrder := 2;
    WebPanel13.Color := clWindow;
    WebPanel13.ElementBodyClassName := 'card-body';
    WebPanel13.ElementFont := efCSS;
    WebPanel13.Font.Charset := DEFAULT_CHARSET;
    WebPanel13.Font.Color := clNone;
    WebPanel13.Font.Height := -15;
    WebPanel13.Font.Name := 'Segoe UI';
    WebPanel13.Font.Style := [];
    WebPanel13.ParentFont := False;
    WebPanel13.TabOrder := 2;
    WebPanel14.SetParentComponent(WebResponsiveGridPanel1);
    WebPanel14.Name := 'WebPanel14';
    WebPanel14.Left := 401;
    WebPanel14.Top := 150;
    WebPanel14.Width := 401;
    WebPanel14.Height := 150;
    WebPanel14.ElementClassName := 'web-panel';
    WebPanel14.WidthStyle := ssPercent;
    WebPanel14.Anchors := [];
    WebPanel14.ChildOrder := 3;
    WebPanel14.Color := clWindow;
    WebPanel14.ElementBodyClassName := 'card-body';
    WebPanel14.ElementFont := efCSS;
    WebPanel14.Font.Charset := DEFAULT_CHARSET;
    WebPanel14.Font.Color := clNone;
    WebPanel14.Font.Height := -15;
    WebPanel14.Font.Name := 'Segoe UI';
    WebPanel14.Font.Style := [];
    WebPanel14.ParentFont := False;
    WebPanel14.TabOrder := 3;
    WebPanel15.SetParentComponent(WebResponsiveGridPanel1);
    WebPanel15.Name := 'WebPanel15';
    WebPanel15.Left := 0;
    WebPanel15.Top := 300;
    WebPanel15.Width := 401;
    WebPanel15.Height := 150;
    WebPanel15.ElementClassName := 'web-panel';
    WebPanel15.WidthStyle := ssPercent;
    WebPanel15.Anchors := [];
    WebPanel15.ChildOrder := 4;
    WebPanel15.Color := clWindow;
    WebPanel15.ElementBodyClassName := 'card-body';
    WebPanel15.ElementFont := efCSS;
    WebPanel15.Font.Charset := DEFAULT_CHARSET;
    WebPanel15.Font.Color := clNone;
    WebPanel15.Font.Height := -15;
    WebPanel15.Font.Name := 'Segoe UI';
    WebPanel15.Font.Style := [];
    WebPanel15.ParentFont := False;
    WebPanel15.TabOrder := 4;
    WebPanel16.SetParentComponent(WebResponsiveGridPanel1);
    WebPanel16.Name := 'WebPanel16';
    WebPanel16.Left := 401;
    WebPanel16.Top := 300;
    WebPanel16.Width := 401;
    WebPanel16.Height := 150;
    WebPanel16.ElementClassName := 'web-panel';
    WebPanel16.WidthStyle := ssPercent;
    WebPanel16.Anchors := [];
    WebPanel16.ChildOrder := 5;
    WebPanel16.Color := clWindow;
    WebPanel16.ElementBodyClassName := 'card-body';
    WebPanel16.ElementFont := efCSS;
    WebPanel16.Font.Charset := DEFAULT_CHARSET;
    WebPanel16.Font.Color := clNone;
    WebPanel16.Font.Height := -15;
    WebPanel16.Font.Name := 'Segoe UI';
    WebPanel16.Font.Style := [];
    WebPanel16.ParentFont := False;
    WebPanel16.TabOrder := 5;
    WebPanel17.SetParentComponent(WebResponsiveGridPanel1);
    WebPanel17.Name := 'WebPanel17';
    WebPanel17.Left := 0;
    WebPanel17.Top := 450;
    WebPanel17.Width := 401;
    WebPanel17.Height := 150;
    WebPanel17.ElementClassName := 'web-panel';
    WebPanel17.WidthStyle := ssPercent;
    WebPanel17.Anchors := [];
    WebPanel17.ChildOrder := 6;
    WebPanel17.Color := clWindow;
    WebPanel17.ElementBodyClassName := 'card-body';
    WebPanel17.ElementFont := efCSS;
    WebPanel17.Font.Charset := DEFAULT_CHARSET;
    WebPanel17.Font.Color := clNone;
    WebPanel17.Font.Height := -15;
    WebPanel17.Font.Name := 'Segoe UI';
    WebPanel17.Font.Style := [];
    WebPanel17.ParentFont := False;
    WebPanel17.TabOrder := 6;
    WebPanel18.SetParentComponent(WebResponsiveGridPanel1);
    WebPanel18.Name := 'WebPanel18';
    WebPanel18.Left := 401;
    WebPanel18.Top := 450;
    WebPanel18.Width := 401;
    WebPanel18.Height := 150;
    WebPanel18.ElementClassName := 'web-panel';
    WebPanel18.WidthStyle := ssPercent;
    WebPanel18.Anchors := [];
    WebPanel18.ChildOrder := 7;
    WebPanel18.Color := clWindow;
    WebPanel18.ElementBodyClassName := 'card-body';
    WebPanel18.ElementFont := efCSS;
    WebPanel18.Font.Charset := DEFAULT_CHARSET;
    WebPanel18.Font.Color := clNone;
    WebPanel18.Font.Height := -15;
    WebPanel18.Font.Name := 'Segoe UI';
    WebPanel18.Font.Style := [];
    WebPanel18.ParentFont := False;
    WebPanel18.TabOrder := 7;
    WebResponsiveGridPanel3.SetParentComponent(WebPageControlSheetOther);
    WebResponsiveGridPanel3.Name := 'WebResponsiveGridPanel3';
    WebResponsiveGridPanel3.Left := 0;
    WebResponsiveGridPanel3.Top := 1897;
    WebResponsiveGridPanel3.Width := 802;
    WebResponsiveGridPanel3.Height := 0;
    WebResponsiveGridPanel3.Margins.Left := 50;
    WebResponsiveGridPanel3.Margins.Top := 50;
    WebResponsiveGridPanel3.Margins.Right := 50;
    WebResponsiveGridPanel3.Margins.Bottom := 50;
    WebResponsiveGridPanel3.HeightStyle := ssAuto;
    WebResponsiveGridPanel3.Align := alTop;
    WebResponsiveGridPanel3.ChildOrder := 1;
    WebResponsiveGridPanel3.ControlCollection.Clear;
    with WebResponsiveGridPanel3.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebPanel26;
    end;
    with WebResponsiveGridPanel3.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel27;
    end;
    with WebResponsiveGridPanel3.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel28;
    end;
    with WebResponsiveGridPanel3.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel29;
    end;
    with WebResponsiveGridPanel3.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel30;
    end;
    with WebResponsiveGridPanel3.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel31;
    end;
    with WebResponsiveGridPanel3.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel32;
    end;
    with WebResponsiveGridPanel3.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel33;
    end;
    WebResponsiveGridPanel3.Color := clNone;
    WebResponsiveGridPanel3.ElementFont := efCSS;
    WebResponsiveGridPanel3.Layout.Clear;
    with WebResponsiveGridPanel3.Layout.Add do
    begin
      Description := 'Smartphone';
      Style := '1fr';
      Width := 450;
    end;
    with WebResponsiveGridPanel3.Layout.Add do
    begin
      Description := 'Tablet';
      Style := '1fr 1fr 1FR';
      Width := 750;
    end;
    WebPanel26.SetParentComponent(WebResponsiveGridPanel3);
    WebPanel26.Name := 'WebPanel26';
    WebPanel26.Left := 0;
    WebPanel26.Top := 0;
    WebPanel26.Width := 401;
    WebPanel26.Height := 150;
    WebPanel26.ElementClassName := 'web-panel';
    WebPanel26.WidthStyle := ssPercent;
    WebPanel26.Anchors := [];
    WebPanel26.Color := clWindow;
    WebPanel26.ElementBodyClassName := 'card-body';
    WebPanel26.ElementFont := efCSS;
    WebPanel26.Font.Charset := DEFAULT_CHARSET;
    WebPanel26.Font.Color := clNone;
    WebPanel26.Font.Height := -15;
    WebPanel26.Font.Name := 'Segoe UI';
    WebPanel26.Font.Style := [];
    WebPanel26.ParentFont := False;
    WebPanel26.TabOrder := 0;
    WebHTMLContainer4.SetParentComponent(WebPanel26);
    WebHTMLContainer4.Name := 'WebHTMLContainer4';
    WebHTMLContainer4.Left := 0;
    WebHTMLContainer4.Top := 0;
    WebHTMLContainer4.Width := 401;
    WebHTMLContainer4.Height := 150;
    WebHTMLContainer4.Margins.Left := 20;
    WebHTMLContainer4.Margins.Top := 20;
    WebHTMLContainer4.Margins.Right := 20;
    WebHTMLContainer4.Margins.Bottom := 20;
    WebHTMLContainer4.Align := alClient;
    WebHTMLContainer4.ChildOrder := 1;
    WebHTMLContainer4.ElementFont := efCSS;
    WebHTMLContainer4.Font.Charset := DEFAULT_CHARSET;
    WebHTMLContainer4.Font.Color := clBackground;
    WebHTMLContainer4.Font.Height := -15;
    WebHTMLContainer4.Font.Name := 'Segoe UI';
    WebHTMLContainer4.Font.Style := [];
    WebHTMLContainer4.HTML.BeginUpdate;
    try
      WebHTMLContainer4.HTML.Clear;
      WebHTMLContainer4.HTML.Add('<B><FONT size="12" class="header-text"><P align="center" style="color: #C0C0C0;">MAIN PRODUCT NAME</P></FONT></B>');
      WebHTMLContainer4.HTML.Add('<FONT size="10" class="main-text"><P align="center" style="color: #C0C0C0;">My Main Text</P></FONT>');
      WebHTMLContainer4.HTML.Add('<FONT size="8" class="small-text"><P align="center" style="color: #C0C0C0;">My Small Text</P></FONT>');
    finally
      WebHTMLContainer4.HTML.EndUpdate;
    end;
    WebPanel27.SetParentComponent(WebResponsiveGridPanel3);
    WebPanel27.Name := 'WebPanel27';
    WebPanel27.Left := 401;
    WebPanel27.Top := 0;
    WebPanel27.Width := 401;
    WebPanel27.Height := 150;
    WebPanel27.ElementClassName := 'web-panel';
    WebPanel27.WidthStyle := ssPercent;
    WebPanel27.Anchors := [];
    WebPanel27.ChildOrder := 1;
    WebPanel27.Color := clWindow;
    WebPanel27.ElementBodyClassName := 'card-body';
    WebPanel27.ElementFont := efCSS;
    WebPanel27.Font.Charset := DEFAULT_CHARSET;
    WebPanel27.Font.Color := clNone;
    WebPanel27.Font.Height := -15;
    WebPanel27.Font.Name := 'Segoe UI';
    WebPanel27.Font.Style := [];
    WebPanel27.ParentFont := False;
    WebPanel27.TabOrder := 1;
    WebHTMLContainer20.SetParentComponent(WebPanel27);
    WebHTMLContainer20.Name := 'WebHTMLContainer20';
    WebHTMLContainer20.Left := 0;
    WebHTMLContainer20.Top := 90;
    WebHTMLContainer20.Width := 401;
    WebHTMLContainer20.Height := 60;
    WebHTMLContainer20.Margins.Left := 20;
    WebHTMLContainer20.Margins.Top := 20;
    WebHTMLContainer20.Margins.Right := 20;
    WebHTMLContainer20.Margins.Bottom := 20;
    WebHTMLContainer20.Align := alBottom;
    WebHTMLContainer20.ChildOrder := 1;
    WebHTMLContainer20.ElementFont := efCSS;
    WebHTMLContainer20.Font.Charset := DEFAULT_CHARSET;
    WebHTMLContainer20.Font.Color := clBackground;
    WebHTMLContainer20.Font.Height := -15;
    WebHTMLContainer20.Font.Name := 'Segoe UI';
    WebHTMLContainer20.Font.Style := [];
    WebHTMLContainer20.HTML.BeginUpdate;
    try
      WebHTMLContainer20.HTML.Clear;
      WebHTMLContainer20.HTML.Add('<FONT color="#000000"><FONT size="12" class="header-text"><P align="center" style="color: #C0C0C0;">BANNER ALONG THE ');
      WebHTMLContainer20.HTML.Add('BOTTOM</P></FONT></FONT>');
    finally
      WebHTMLContainer20.HTML.EndUpdate;
    end;
    WebPanel28.SetParentComponent(WebResponsiveGridPanel3);
    WebPanel28.Name := 'WebPanel28';
    WebPanel28.Left := 802;
    WebPanel28.Top := 0;
    WebPanel28.Width := 0;
    WebPanel28.Height := 150;
    WebPanel28.ElementClassName := 'web-panel';
    WebPanel28.WidthStyle := ssPercent;
    WebPanel28.Anchors := [];
    WebPanel28.ChildOrder := 2;
    WebPanel28.Color := clWindow;
    WebPanel28.ElementBodyClassName := 'card-body';
    WebPanel28.ElementFont := efCSS;
    WebPanel28.Font.Charset := DEFAULT_CHARSET;
    WebPanel28.Font.Color := clNone;
    WebPanel28.Font.Height := -15;
    WebPanel28.Font.Name := 'Segoe UI';
    WebPanel28.Font.Style := [];
    WebPanel28.ParentFont := False;
    WebPanel28.TabOrder := 2;
    WebHTMLContainer26.SetParentComponent(WebPanel28);
    WebHTMLContainer26.Name := 'WebHTMLContainer26';
    WebHTMLContainer26.Left := 0;
    WebHTMLContainer26.Top := 0;
    WebHTMLContainer26.Width := 0;
    WebHTMLContainer26.Height := 150;
    WebHTMLContainer26.Margins.Left := 20;
    WebHTMLContainer26.Margins.Top := 20;
    WebHTMLContainer26.Margins.Right := 20;
    WebHTMLContainer26.Margins.Bottom := 20;
    WebHTMLContainer26.Align := alClient;
    WebHTMLContainer26.ChildOrder := 1;
    WebHTMLContainer26.ElementFont := efCSS;
    WebHTMLContainer26.Font.Charset := DEFAULT_CHARSET;
    WebHTMLContainer26.Font.Color := clBackground;
    WebHTMLContainer26.Font.Height := -15;
    WebHTMLContainer26.Font.Name := 'Segoe UI';
    WebHTMLContainer26.Font.Style := [];
    WebHTMLContainer26.HTML.BeginUpdate;
    try
      WebHTMLContainer26.HTML.Clear;
      WebHTMLContainer26.HTML.Add('<FONT size="12" class="header-text"><P align="center" style="color: #C0C0C0;">My Header</P></FONT>');
      WebHTMLContainer26.HTML.Add('<FONT size="10" class="main-text"><P align="center" style="color: #C0C0C0;">My Main Text</P></FONT>');
      WebHTMLContainer26.HTML.Add('<FONT size="8" class="small-text"><P align="center" style="color: #C0C0C0;">My Small Text</P></FONT>');
    finally
      WebHTMLContainer26.HTML.EndUpdate;
    end;
    WebPanel29.SetParentComponent(WebResponsiveGridPanel3);
    WebPanel29.Name := 'WebPanel29';
    WebPanel29.Left := 0;
    WebPanel29.Top := 150;
    WebPanel29.Width := 401;
    WebPanel29.Height := 150;
    WebPanel29.ElementClassName := 'web-panel';
    WebPanel29.WidthStyle := ssPercent;
    WebPanel29.Anchors := [];
    WebPanel29.ChildOrder := 3;
    WebPanel29.Color := clWindow;
    WebPanel29.ElementBodyClassName := 'card-body';
    WebPanel29.ElementFont := efCSS;
    WebPanel29.Font.Charset := DEFAULT_CHARSET;
    WebPanel29.Font.Color := clNone;
    WebPanel29.Font.Height := -15;
    WebPanel29.Font.Name := 'Segoe UI';
    WebPanel29.Font.Style := [];
    WebPanel29.ParentFont := False;
    WebPanel29.TabOrder := 3;
    WebHTMLContainer27.SetParentComponent(WebPanel29);
    WebHTMLContainer27.Name := 'WebHTMLContainer27';
    WebHTMLContainer27.Left := 0;
    WebHTMLContainer27.Top := 0;
    WebHTMLContainer27.Width := 401;
    WebHTMLContainer27.Height := 150;
    WebHTMLContainer27.Margins.Left := 20;
    WebHTMLContainer27.Margins.Top := 20;
    WebHTMLContainer27.Margins.Right := 20;
    WebHTMLContainer27.Margins.Bottom := 20;
    WebHTMLContainer27.Align := alClient;
    WebHTMLContainer27.ChildOrder := 1;
    WebHTMLContainer27.ElementFont := efCSS;
    WebHTMLContainer27.Font.Charset := DEFAULT_CHARSET;
    WebHTMLContainer27.Font.Color := clBackground;
    WebHTMLContainer27.Font.Height := -15;
    WebHTMLContainer27.Font.Name := 'Segoe UI';
    WebHTMLContainer27.Font.Style := [];
    WebHTMLContainer27.HTML.BeginUpdate;
    try
      WebHTMLContainer27.HTML.Clear;
      WebHTMLContainer27.HTML.Add('<FONT size="12" class="header-text"><P align="center" style="color: #C0C0C0;">My Header</P></FONT>');
      WebHTMLContainer27.HTML.Add('<FONT size="10" class="main-text"><P align="center" style="color: #C0C0C0;">My Main Text</P></FONT>');
      WebHTMLContainer27.HTML.Add('<FONT size="8" class="small-text"><P align="center" style="color: #C0C0C0;">My Small Text</P></FONT>');
    finally
      WebHTMLContainer27.HTML.EndUpdate;
    end;
    WebPanel30.SetParentComponent(WebResponsiveGridPanel3);
    WebPanel30.Name := 'WebPanel30';
    WebPanel30.Left := 401;
    WebPanel30.Top := 150;
    WebPanel30.Width := 401;
    WebPanel30.Height := 150;
    WebPanel30.ElementClassName := 'web-panel';
    WebPanel30.WidthStyle := ssPercent;
    WebPanel30.Anchors := [];
    WebPanel30.ChildOrder := 4;
    WebPanel30.Color := clWindow;
    WebPanel30.ElementBodyClassName := 'card-body';
    WebPanel30.ElementFont := efCSS;
    WebPanel30.Font.Charset := DEFAULT_CHARSET;
    WebPanel30.Font.Color := clNone;
    WebPanel30.Font.Height := -15;
    WebPanel30.Font.Name := 'Segoe UI';
    WebPanel30.Font.Style := [];
    WebPanel30.ParentFont := False;
    WebPanel30.TabOrder := 4;
    WebHTMLContainer28.SetParentComponent(WebPanel30);
    WebHTMLContainer28.Name := 'WebHTMLContainer28';
    WebHTMLContainer28.Left := 0;
    WebHTMLContainer28.Top := 0;
    WebHTMLContainer28.Width := 401;
    WebHTMLContainer28.Height := 150;
    WebHTMLContainer28.Margins.Left := 20;
    WebHTMLContainer28.Margins.Top := 20;
    WebHTMLContainer28.Margins.Right := 20;
    WebHTMLContainer28.Margins.Bottom := 20;
    WebHTMLContainer28.Align := alClient;
    WebHTMLContainer28.ChildOrder := 1;
    WebHTMLContainer28.ElementFont := efCSS;
    WebHTMLContainer28.Font.Charset := DEFAULT_CHARSET;
    WebHTMLContainer28.Font.Color := clBackground;
    WebHTMLContainer28.Font.Height := -15;
    WebHTMLContainer28.Font.Name := 'Segoe UI';
    WebHTMLContainer28.Font.Style := [];
    WebHTMLContainer28.HTML.BeginUpdate;
    try
      WebHTMLContainer28.HTML.Clear;
      WebHTMLContainer28.HTML.Add('<FONT size="12" class="header-text"><P align="center" style="color: #C0C0C0;">My Header</P></FONT>');
      WebHTMLContainer28.HTML.Add('<FONT size="10" class="main-text"><P align="center" style="color: #C0C0C0;">My Main Text</P></FONT>');
      WebHTMLContainer28.HTML.Add('<FONT size="8" class="small-text"><P align="center" style="color: #C0C0C0;">My Small Text</P></FONT>');
    finally
      WebHTMLContainer28.HTML.EndUpdate;
    end;
    WebPanel31.SetParentComponent(WebResponsiveGridPanel3);
    WebPanel31.Name := 'WebPanel31';
    WebPanel31.Left := 802;
    WebPanel31.Top := 150;
    WebPanel31.Width := 0;
    WebPanel31.Height := 150;
    WebPanel31.ElementClassName := 'web-panel';
    WebPanel31.WidthStyle := ssPercent;
    WebPanel31.Anchors := [];
    WebPanel31.ChildOrder := 5;
    WebPanel31.Color := clWindow;
    WebPanel31.ElementBodyClassName := 'card-body';
    WebPanel31.ElementFont := efCSS;
    WebPanel31.Font.Charset := DEFAULT_CHARSET;
    WebPanel31.Font.Color := clNone;
    WebPanel31.Font.Height := -15;
    WebPanel31.Font.Name := 'Segoe UI';
    WebPanel31.Font.Style := [];
    WebPanel31.ParentFont := False;
    WebPanel31.TabOrder := 5;
    WebHTMLContainer29.SetParentComponent(WebPanel31);
    WebHTMLContainer29.Name := 'WebHTMLContainer29';
    WebHTMLContainer29.Left := 0;
    WebHTMLContainer29.Top := 0;
    WebHTMLContainer29.Width := 0;
    WebHTMLContainer29.Height := 150;
    WebHTMLContainer29.Margins.Left := 20;
    WebHTMLContainer29.Margins.Top := 20;
    WebHTMLContainer29.Margins.Right := 20;
    WebHTMLContainer29.Margins.Bottom := 20;
    WebHTMLContainer29.Align := alClient;
    WebHTMLContainer29.ChildOrder := 1;
    WebHTMLContainer29.ElementFont := efCSS;
    WebHTMLContainer29.Font.Charset := DEFAULT_CHARSET;
    WebHTMLContainer29.Font.Color := clBackground;
    WebHTMLContainer29.Font.Height := -15;
    WebHTMLContainer29.Font.Name := 'Segoe UI';
    WebHTMLContainer29.Font.Style := [];
    WebHTMLContainer29.HTML.BeginUpdate;
    try
      WebHTMLContainer29.HTML.Clear;
      WebHTMLContainer29.HTML.Add('<FONT size="12" class="header-text"><P align="center" style="color: #C0C0C0;">My Header</P></FONT>');
      WebHTMLContainer29.HTML.Add('<FONT size="10" class="main-text"><P align="center" style="color: #C0C0C0;">My Main Text</P></FONT>');
      WebHTMLContainer29.HTML.Add('<FONT size="8" class="small-text"><P align="center" style="color: #C0C0C0;">My Small Text</P></FONT>');
    finally
      WebHTMLContainer29.HTML.EndUpdate;
    end;
    WebPanel32.SetParentComponent(WebResponsiveGridPanel3);
    WebPanel32.Name := 'WebPanel32';
    WebPanel32.Left := 0;
    WebPanel32.Top := 300;
    WebPanel32.Width := 401;
    WebPanel32.Height := 150;
    WebPanel32.ElementClassName := 'web-panel';
    WebPanel32.WidthStyle := ssPercent;
    WebPanel32.Anchors := [];
    WebPanel32.ChildOrder := 6;
    WebPanel32.Color := clWindow;
    WebPanel32.ElementBodyClassName := 'card-body';
    WebPanel32.ElementFont := efCSS;
    WebPanel32.Font.Charset := DEFAULT_CHARSET;
    WebPanel32.Font.Color := clNone;
    WebPanel32.Font.Height := -15;
    WebPanel32.Font.Name := 'Segoe UI';
    WebPanel32.Font.Style := [];
    WebPanel32.ParentFont := False;
    WebPanel32.TabOrder := 6;
    WebHTMLContainer30.SetParentComponent(WebPanel32);
    WebHTMLContainer30.Name := 'WebHTMLContainer30';
    WebHTMLContainer30.Left := 0;
    WebHTMLContainer30.Top := 0;
    WebHTMLContainer30.Width := 401;
    WebHTMLContainer30.Height := 150;
    WebHTMLContainer30.Margins.Left := 20;
    WebHTMLContainer30.Margins.Top := 20;
    WebHTMLContainer30.Margins.Right := 20;
    WebHTMLContainer30.Margins.Bottom := 20;
    WebHTMLContainer30.Align := alClient;
    WebHTMLContainer30.ChildOrder := 1;
    WebHTMLContainer30.ElementFont := efCSS;
    WebHTMLContainer30.Font.Charset := DEFAULT_CHARSET;
    WebHTMLContainer30.Font.Color := clBackground;
    WebHTMLContainer30.Font.Height := -15;
    WebHTMLContainer30.Font.Name := 'Segoe UI';
    WebHTMLContainer30.Font.Style := [];
    WebHTMLContainer30.HTML.BeginUpdate;
    try
      WebHTMLContainer30.HTML.Clear;
      WebHTMLContainer30.HTML.Add('<FONT size="12" class="header-text"><P align="center" style="color: #C0C0C0;">My Header</P></FONT>');
      WebHTMLContainer30.HTML.Add('<FONT size="10" class="main-text"><P align="center" style="color: #C0C0C0;">My Main Text</P></FONT>');
      WebHTMLContainer30.HTML.Add('<FONT size="8" class="small-text"><P align="center" style="color: #C0C0C0;">My Small Text</P></FONT>');
    finally
      WebHTMLContainer30.HTML.EndUpdate;
    end;
    WebPanel33.SetParentComponent(WebResponsiveGridPanel3);
    WebPanel33.Name := 'WebPanel33';
    WebPanel33.Left := 401;
    WebPanel33.Top := 300;
    WebPanel33.Width := 401;
    WebPanel33.Height := 150;
    WebPanel33.ElementClassName := 'web-panel';
    WebPanel33.WidthStyle := ssPercent;
    WebPanel33.Anchors := [];
    WebPanel33.ChildOrder := 7;
    WebPanel33.Color := clWindow;
    WebPanel33.ElementBodyClassName := 'card-body';
    WebPanel33.ElementFont := efCSS;
    WebPanel33.Font.Charset := DEFAULT_CHARSET;
    WebPanel33.Font.Color := clNone;
    WebPanel33.Font.Height := -15;
    WebPanel33.Font.Name := 'Segoe UI';
    WebPanel33.Font.Style := [];
    WebPanel33.ParentFont := False;
    WebPanel33.TabOrder := 7;
    WebHTMLContainer31.SetParentComponent(WebPanel33);
    WebHTMLContainer31.Name := 'WebHTMLContainer31';
    WebHTMLContainer31.Left := 0;
    WebHTMLContainer31.Top := 0;
    WebHTMLContainer31.Width := 401;
    WebHTMLContainer31.Height := 150;
    WebHTMLContainer31.Margins.Left := 20;
    WebHTMLContainer31.Margins.Top := 20;
    WebHTMLContainer31.Margins.Right := 20;
    WebHTMLContainer31.Margins.Bottom := 20;
    WebHTMLContainer31.Align := alClient;
    WebHTMLContainer31.ChildOrder := 1;
    WebHTMLContainer31.ElementFont := efCSS;
    WebHTMLContainer31.Font.Charset := DEFAULT_CHARSET;
    WebHTMLContainer31.Font.Color := clBackground;
    WebHTMLContainer31.Font.Height := -15;
    WebHTMLContainer31.Font.Name := 'Segoe UI';
    WebHTMLContainer31.Font.Style := [];
    WebHTMLContainer31.HTML.BeginUpdate;
    try
      WebHTMLContainer31.HTML.Clear;
      WebHTMLContainer31.HTML.Add('<FONT size="12" class="header-text"><P align="center" style="color: #C0C0C0;">My Header</P></FONT>');
      WebHTMLContainer31.HTML.Add('<FONT size="10" class="main-text"><P align="center" style="color: #C0C0C0;">My Main Text</P></FONT>');
      WebHTMLContainer31.HTML.Add('<FONT size="8" class="small-text"><P align="center" style="color: #C0C0C0;">My Small Text</P></FONT>');
    finally
      WebHTMLContainer31.HTML.EndUpdate;
    end;
    WebPageControlSheetLessons.SetParentComponent(WPCMain);
    WebPageControlSheetLessons.Name := 'WebPageControlSheetLessons';
    WebPageControlSheetLessons.Left := 0;
    WebPageControlSheetLessons.Top := 20;
    WebPageControlSheetLessons.Width := 802;
    WebPageControlSheetLessons.Height := 1879;
    WebPageControlSheetLessons.Caption := 'Assessments';
    WebPageControlSheetLessons.ChildOrder := 2;
    WebPageControlSheetLessons.Color := clNone;
    WebPageControlSheetLessons.ElementFont := efCSS;
    WebPageControlSheetLessons.Font.Charset := DEFAULT_CHARSET;
    WebPageControlSheetLessons.Font.Color := clNone;
    WebPageControlSheetLessons.Font.Height := -15;
    WebPageControlSheetLessons.Font.Name := 'Segoe UI';
    WebPageControlSheetLessons.Font.Style := [];
    WebPageControlSheetLessons.ParentFont := False;
    WebResponsiveGridPanel2.SetParentComponent(WebPageControlSheetLessons);
    WebResponsiveGridPanel2.Name := 'WebResponsiveGridPanel2';
    WebResponsiveGridPanel2.Left := 0;
    WebResponsiveGridPanel2.Top := 0;
    WebResponsiveGridPanel2.Width := 802;
    WebResponsiveGridPanel2.Height := 1879;
    WebResponsiveGridPanel2.Margins.Left := 50;
    WebResponsiveGridPanel2.Margins.Top := 50;
    WebResponsiveGridPanel2.Margins.Right := 50;
    WebResponsiveGridPanel2.Margins.Bottom := 50;
    WebResponsiveGridPanel2.HeightStyle := ssAuto;
    WebResponsiveGridPanel2.Align := alClient;
    WebResponsiveGridPanel2.ControlCollection.Clear;
    with WebResponsiveGridPanel2.ControlCollection.Add do
    begin
      Column := 0;
      Row := 0;
      Control := WebPanel19;
    end;
    with WebResponsiveGridPanel2.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel20;
    end;
    with WebResponsiveGridPanel2.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel21;
    end;
    with WebResponsiveGridPanel2.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel22;
    end;
    with WebResponsiveGridPanel2.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel23;
    end;
    with WebResponsiveGridPanel2.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel24;
    end;
    with WebResponsiveGridPanel2.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel25;
    end;
    with WebResponsiveGridPanel2.ControlCollection.Add do
    begin
      Column := 0;
      Row := 1;
      Control := WebPanel34;
    end;
    WebResponsiveGridPanel2.Color := clNone;
    WebResponsiveGridPanel2.ElementFont := efCSS;
    WebResponsiveGridPanel2.Layout.Clear;
    with WebResponsiveGridPanel2.Layout.Add do
    begin
      Description := 'Smartphone';
      Style := '1fr';
      Width := 450;
    end;
    with WebResponsiveGridPanel2.Layout.Add do
    begin
      Description := 'Tablet';
      Style := '1fr 1fr';
      Width := 750;
    end;
    WebPanel19.SetParentComponent(WebResponsiveGridPanel2);
    WebPanel19.Name := 'WebPanel19';
    WebPanel19.Left := 0;
    WebPanel19.Top := 0;
    WebPanel19.Width := 401;
    WebPanel19.Height := 150;
    WebPanel19.ElementClassName := 'web-panel';
    WebPanel19.WidthStyle := ssPercent;
    WebPanel19.Anchors := [];
    WebPanel19.Color := clWindow;
    WebPanel19.ElementBodyClassName := 'card-body';
    WebPanel19.ElementFont := efCSS;
    WebPanel19.TabOrder := 0;
    WebBrowserControl5.SetParentComponent(WebPanel19);
    WebBrowserControl5.Name := 'WebBrowserControl5';
    WebBrowserControl5.AlignWithMargins := True;
    WebBrowserControl5.Left := 15;
    WebBrowserControl5.Top := 15;
    WebBrowserControl5.Width := 371;
    WebBrowserControl5.Height := 120;
    WebBrowserControl5.Margins.Left := 15;
    WebBrowserControl5.Margins.Top := 15;
    WebBrowserControl5.Margins.Right := 15;
    WebBrowserControl5.Margins.Bottom := 15;
    WebBrowserControl5.Align := alClient;
    WebBrowserControl5.Sandbox := [];
    WebBrowserControl5.URL := 'https://app.mindsmith.ai/lesson/cltrio6fb002gjw08dw5ualzj/preview';
    WebPanel20.SetParentComponent(WebResponsiveGridPanel2);
    WebPanel20.Name := 'WebPanel20';
    WebPanel20.Left := 401;
    WebPanel20.Top := 0;
    WebPanel20.Width := 401;
    WebPanel20.Height := 150;
    WebPanel20.ElementClassName := 'web-panel';
    WebPanel20.WidthStyle := ssPercent;
    WebPanel20.Anchors := [];
    WebPanel20.ChildOrder := 1;
    WebPanel20.Color := clWindow;
    WebPanel20.ElementBodyClassName := 'card-body';
    WebPanel20.ElementFont := efCSS;
    WebPanel20.TabOrder := 1;
    WebBrowserControl8.SetParentComponent(WebPanel20);
    WebBrowserControl8.Name := 'WebBrowserControl8';
    WebBrowserControl8.AlignWithMargins := True;
    WebBrowserControl8.Left := 15;
    WebBrowserControl8.Top := 15;
    WebBrowserControl8.Width := 371;
    WebBrowserControl8.Height := 120;
    WebBrowserControl8.Margins.Left := 15;
    WebBrowserControl8.Margins.Top := 15;
    WebBrowserControl8.Margins.Right := 15;
    WebBrowserControl8.Margins.Bottom := 15;
    WebBrowserControl8.Align := alClient;
    WebBrowserControl8.Sandbox := [];
    WebBrowserControl8.URL := 'https://app.mindsmith.ai/lesson/cltrf4vs50038jt08uq9hq9rn/preview';
    WebPanel21.SetParentComponent(WebResponsiveGridPanel2);
    WebPanel21.Name := 'WebPanel21';
    WebPanel21.Left := 0;
    WebPanel21.Top := 150;
    WebPanel21.Width := 401;
    WebPanel21.Height := 150;
    WebPanel21.ElementClassName := 'web-panel';
    WebPanel21.WidthStyle := ssPercent;
    WebPanel21.Anchors := [];
    WebPanel21.ChildOrder := 2;
    WebPanel21.Color := clWindow;
    WebPanel21.ElementBodyClassName := 'card-body';
    WebPanel21.ElementFont := efCSS;
    WebPanel21.TabOrder := 2;
    WebHTMLContainer12.SetParentComponent(WebPanel21);
    WebHTMLContainer12.Name := 'WebHTMLContainer12';
    WebHTMLContainer12.AlignWithMargins := True;
    WebHTMLContainer12.Left := 15;
    WebHTMLContainer12.Top := 15;
    WebHTMLContainer12.Width := 371;
    WebHTMLContainer12.Height := 120;
    WebHTMLContainer12.Margins.Left := 15;
    WebHTMLContainer12.Margins.Top := 15;
    WebHTMLContainer12.Margins.Right := 15;
    WebHTMLContainer12.Margins.Bottom := 15;
    WebHTMLContainer12.Align := alClient;
    WebHTMLContainer12.ChildOrder := 1;
    WebHTMLContainer12.ElementFont := efCSS;
    WebHTMLContainer12.HTML.BeginUpdate;
    try
      WebHTMLContainer12.HTML.Clear;
      WebHTMLContainer12.HTML.Add('<p style="font-size: calc(min(30px, 18px + 2vw)); font-weight: bold; text-align: center;">HOW IS AI USED ?</p>');
      WebHTMLContainer12.HTML.Add('<p style="font-size: calc(min(14px, 18px + 2vw));;text-align: center">Lorem ipsum dolor sit amet, consectetur ');
      WebHTMLContainer12.HTML.Add('adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco ');
      WebHTMLContainer12.HTML.Add('laboris </p>');
    finally
      WebHTMLContainer12.HTML.EndUpdate;
    end;
    WebPanel22.SetParentComponent(WebResponsiveGridPanel2);
    WebPanel22.Name := 'WebPanel22';
    WebPanel22.Left := 401;
    WebPanel22.Top := 150;
    WebPanel22.Width := 401;
    WebPanel22.Height := 150;
    WebPanel22.ElementClassName := 'web-panel';
    WebPanel22.WidthStyle := ssPercent;
    WebPanel22.Anchors := [];
    WebPanel22.ChildOrder := 3;
    WebPanel22.Color := clWindow;
    WebPanel22.ElementBodyClassName := 'card-body';
    WebPanel22.ElementFont := efCSS;
    WebPanel22.TabOrder := 3;
    WebHTMLContainer13.SetParentComponent(WebPanel22);
    WebHTMLContainer13.Name := 'WebHTMLContainer13';
    WebHTMLContainer13.AlignWithMargins := True;
    WebHTMLContainer13.Left := 15;
    WebHTMLContainer13.Top := 15;
    WebHTMLContainer13.Width := 371;
    WebHTMLContainer13.Height := 120;
    WebHTMLContainer13.Margins.Left := 15;
    WebHTMLContainer13.Margins.Top := 15;
    WebHTMLContainer13.Margins.Right := 15;
    WebHTMLContainer13.Margins.Bottom := 15;
    WebHTMLContainer13.Align := alClient;
    WebHTMLContainer13.ChildOrder := 1;
    WebHTMLContainer13.ElementFont := efCSS;
    WebHTMLContainer13.HTML.BeginUpdate;
    try
      WebHTMLContainer13.HTML.Clear;
      WebHTMLContainer13.HTML.Add('<p style="font-size: calc(min(30px, 18px + 2vw)); font-weight: bold; text-align: center;">HOW IS AI USED ?</p>');
      WebHTMLContainer13.HTML.Add('<p style="font-size: calc(min(14px, 18px + 2vw));;text-align: center">Lorem ipsum dolor sit amet, consectetur ');
      WebHTMLContainer13.HTML.Add('adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco ');
      WebHTMLContainer13.HTML.Add('laboris </p>');
    finally
      WebHTMLContainer13.HTML.EndUpdate;
    end;
    WebPanel23.SetParentComponent(WebResponsiveGridPanel2);
    WebPanel23.Name := 'WebPanel23';
    WebPanel23.Left := 0;
    WebPanel23.Top := 300;
    WebPanel23.Width := 401;
    WebPanel23.Height := 150;
    WebPanel23.ElementClassName := 'web-panel';
    WebPanel23.WidthStyle := ssPercent;
    WebPanel23.Anchors := [];
    WebPanel23.ChildOrder := 4;
    WebPanel23.Color := clWindow;
    WebPanel23.ElementBodyClassName := 'card-body';
    WebPanel23.ElementFont := efCSS;
    WebPanel23.TabOrder := 4;
    WebHTMLContainer7.SetParentComponent(WebPanel23);
    WebHTMLContainer7.Name := 'WebHTMLContainer7';
    WebHTMLContainer7.AlignWithMargins := True;
    WebHTMLContainer7.Left := 15;
    WebHTMLContainer7.Top := 15;
    WebHTMLContainer7.Width := 371;
    WebHTMLContainer7.Height := 120;
    WebHTMLContainer7.Margins.Left := 15;
    WebHTMLContainer7.Margins.Top := 15;
    WebHTMLContainer7.Margins.Right := 15;
    WebHTMLContainer7.Margins.Bottom := 15;
    WebHTMLContainer7.Align := alClient;
    WebHTMLContainer7.ChildOrder := 1;
    WebHTMLContainer7.ElementFont := efCSS;
    WebHTMLContainer7.HTML.BeginUpdate;
    try
      WebHTMLContainer7.HTML.Clear;
      WebHTMLContainer7.HTML.Add('<p style="font-size: calc(min(30px, 18px + 2vw)); font-weight: bold; text-align: center;">HOW IS AI USED ?</p>');
      WebHTMLContainer7.HTML.Add('<p style="font-size: calc(min(14px, 18px + 2vw));;text-align: center">Lorem ipsum dolor sit amet, consectetur ');
      WebHTMLContainer7.HTML.Add('adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco ');
      WebHTMLContainer7.HTML.Add('laboris </p>');
    finally
      WebHTMLContainer7.HTML.EndUpdate;
    end;
    WebPanel24.SetParentComponent(WebResponsiveGridPanel2);
    WebPanel24.Name := 'WebPanel24';
    WebPanel24.Left := 401;
    WebPanel24.Top := 300;
    WebPanel24.Width := 401;
    WebPanel24.Height := 150;
    WebPanel24.ElementClassName := 'web-panel';
    WebPanel24.WidthStyle := ssPercent;
    WebPanel24.Anchors := [];
    WebPanel24.ChildOrder := 5;
    WebPanel24.Color := clWindow;
    WebPanel24.ElementBodyClassName := 'card-body';
    WebPanel24.ElementFont := efCSS;
    WebPanel24.TabOrder := 5;
    WebHTMLContainer8.SetParentComponent(WebPanel24);
    WebHTMLContainer8.Name := 'WebHTMLContainer8';
    WebHTMLContainer8.AlignWithMargins := True;
    WebHTMLContainer8.Left := 15;
    WebHTMLContainer8.Top := 15;
    WebHTMLContainer8.Width := 371;
    WebHTMLContainer8.Height := 120;
    WebHTMLContainer8.Margins.Left := 15;
    WebHTMLContainer8.Margins.Top := 15;
    WebHTMLContainer8.Margins.Right := 15;
    WebHTMLContainer8.Margins.Bottom := 15;
    WebHTMLContainer8.Align := alClient;
    WebHTMLContainer8.ChildOrder := 1;
    WebHTMLContainer8.ElementFont := efCSS;
    WebHTMLContainer8.HTML.BeginUpdate;
    try
      WebHTMLContainer8.HTML.Clear;
      WebHTMLContainer8.HTML.Add('<p style="font-size: calc(min(30px, 18px + 2vw)); font-weight: bold; text-align: center;">HOW IS AI USED ?</p>');
      WebHTMLContainer8.HTML.Add('<p style="font-size: calc(min(14px, 18px + 2vw));;text-align: center">Lorem ipsum dolor sit amet, consectetur ');
      WebHTMLContainer8.HTML.Add('adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco ');
      WebHTMLContainer8.HTML.Add('laboris </p>');
    finally
      WebHTMLContainer8.HTML.EndUpdate;
    end;
    WebPanel25.SetParentComponent(WebResponsiveGridPanel2);
    WebPanel25.Name := 'WebPanel25';
    WebPanel25.Left := 0;
    WebPanel25.Top := 450;
    WebPanel25.Width := 401;
    WebPanel25.Height := 150;
    WebPanel25.ElementClassName := 'web-panel';
    WebPanel25.WidthStyle := ssPercent;
    WebPanel25.Anchors := [];
    WebPanel25.ChildOrder := 6;
    WebPanel25.Color := clWindow;
    WebPanel25.ElementBodyClassName := 'card-body';
    WebPanel25.ElementFont := efCSS;
    WebPanel25.TabOrder := 6;
    WebHTMLContainer10.SetParentComponent(WebPanel25);
    WebHTMLContainer10.Name := 'WebHTMLContainer10';
    WebHTMLContainer10.AlignWithMargins := True;
    WebHTMLContainer10.Left := 15;
    WebHTMLContainer10.Top := 15;
    WebHTMLContainer10.Width := 371;
    WebHTMLContainer10.Height := 120;
    WebHTMLContainer10.Margins.Left := 15;
    WebHTMLContainer10.Margins.Top := 15;
    WebHTMLContainer10.Margins.Right := 15;
    WebHTMLContainer10.Margins.Bottom := 15;
    WebHTMLContainer10.Align := alClient;
    WebHTMLContainer10.ChildOrder := 1;
    WebHTMLContainer10.ElementFont := efCSS;
    WebHTMLContainer10.HTML.BeginUpdate;
    try
      WebHTMLContainer10.HTML.Clear;
      WebHTMLContainer10.HTML.Add('<p style="font-size: calc(min(30px, 18px + 2vw)); font-weight: bold; text-align: center;">HOW IS AI USED ?</p>');
      WebHTMLContainer10.HTML.Add('<p style="font-size: calc(min(14px, 18px + 2vw));;text-align: center">Lorem ipsum dolor sit amet, consectetur ');
      WebHTMLContainer10.HTML.Add('adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco ');
      WebHTMLContainer10.HTML.Add('laboris </p>');
    finally
      WebHTMLContainer10.HTML.EndUpdate;
    end;
    WebPanel34.SetParentComponent(WebResponsiveGridPanel2);
    WebPanel34.Name := 'WebPanel34';
    WebPanel34.Left := 401;
    WebPanel34.Top := 450;
    WebPanel34.Width := 401;
    WebPanel34.Height := 150;
    WebPanel34.ElementClassName := 'web-panel';
    WebPanel34.WidthStyle := ssPercent;
    WebPanel34.Anchors := [];
    WebPanel34.ChildOrder := 7;
    WebPanel34.Color := clWindow;
    WebPanel34.ElementBodyClassName := 'card-body';
    WebPanel34.ElementFont := efCSS;
    WebPanel34.TabOrder := 7;
    WebHTMLContainer11.SetParentComponent(WebPanel34);
    WebHTMLContainer11.Name := 'WebHTMLContainer11';
    WebHTMLContainer11.AlignWithMargins := True;
    WebHTMLContainer11.Left := 15;
    WebHTMLContainer11.Top := 15;
    WebHTMLContainer11.Width := 371;
    WebHTMLContainer11.Height := 120;
    WebHTMLContainer11.Margins.Left := 15;
    WebHTMLContainer11.Margins.Top := 15;
    WebHTMLContainer11.Margins.Right := 15;
    WebHTMLContainer11.Margins.Bottom := 15;
    WebHTMLContainer11.Align := alClient;
    WebHTMLContainer11.ChildOrder := 1;
    WebHTMLContainer11.ElementFont := efCSS;
    WebHTMLContainer11.HTML.BeginUpdate;
    try
      WebHTMLContainer11.HTML.Clear;
      WebHTMLContainer11.HTML.Add('<p style="font-size: calc(min(30px, 18px + 2vw)); font-weight: bold; text-align: center;">HOW IS AI USED ?</p>');
      WebHTMLContainer11.HTML.Add('<p style="font-size: calc(min(14px, 18px + 2vw));;text-align: center">Lorem ipsum dolor sit amet, consectetur ');
      WebHTMLContainer11.HTML.Add('adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco ');
      WebHTMLContainer11.HTML.Add('laboris </p>');
    finally
      WebHTMLContainer11.HTML.EndUpdate;
    end;
    WPCMainSheetLogin.SetParentComponent(WPCMain);
    WPCMainSheetLogin.Name := 'WPCMainSheetLogin';
    WPCMainSheetLogin.Left := 0;
    WPCMainSheetLogin.Top := 20;
    WPCMainSheetLogin.Width := 802;
    WPCMainSheetLogin.Height := 1879;
    WPCMainSheetLogin.Align := alClient;
    WPCMainSheetLogin.BorderStyle := bsNone;
    WPCMainSheetLogin.Caption := 'Login';
    WPCMainSheetLogin.ChildOrder := 3;
    WPCMainSheetLogin.Color := clNone;
    WPCMainSheetLogin.ElementFont := efCSS;
    WebPanel35.SetParentComponent(WPCMainSheetLogin);
    WebPanel35.Name := 'WebPanel35';
    WebPanel35.Left := 0;
    WebPanel35.Top := 0;
    WebPanel35.Width := 802;
    WebPanel35.Height := 1879;
    WebPanel35.ElementClassName := 'card';
    WebPanel35.Align := alClient;
    WebPanel35.ChildOrder := 1;
    WebPanel35.ElementBodyClassName := 'card-body';
    WebPanel35.ElementFont := efCSS;
    WebPanel35.TabOrder := 0;
    WebPageControlLogin.SetParentComponent(WebPanel35);
    WebPageControlLogin.Name := 'WebPageControlLogin';
    WebPageControlLogin.AlignWithMargins := True;
    WebPageControlLogin.Left := 50;
    WebPageControlLogin.Top := 50;
    WebPageControlLogin.Width := 702;
    WebPageControlLogin.Height := 1779;
    WebPageControlLogin.Margins.Left := 50;
    WebPageControlLogin.Margins.Top := 50;
    WebPageControlLogin.Margins.Right := 50;
    WebPageControlLogin.Margins.Bottom := 50;
    WebPageControlLogin.ElementClassName := 'nav nav-tabs';
    WebPageControlLogin.WidthStyle := ssPercent;
    WebPageControlLogin.WidthPercent := 90.000000000000000000;
    WebPageControlLogin.Align := alClient;
    WebPageControlLogin.ChildOrder := 3;
    WebPageControlLogin.ElementTabClassName := 'nav-link';
    WebPageControlLogin.ElementTabActiveClassName := 'nav-link active';
    WebPageControlLogin.ElementTabItemClassName := 'nav-item';
    WebPageControlLogin.ElementFont := efCSS;
    WebPageControlLogin.TabIndex := 0;
    WebPageControlLogin.TabOrder := 0;
    WebPageControl1Sheet1.SetParentComponent(WebPageControlLogin);
    WebPageControl1Sheet1.Name := 'WebPageControl1Sheet1';
    WebPageControl1Sheet1.Left := 0;
    WebPageControl1Sheet1.Top := 20;
    WebPageControl1Sheet1.Width := 702;
    WebPageControl1Sheet1.Height := 1759;
    WebPageControl1Sheet1.Caption := 'Login';
    WebPageControl1Sheet1.ChildOrder := 3;
    WebPageControl1Sheet1.Color := clNone;
    WebPageControl1Sheet1.ElementFont := efCSS;
    WebPanelLogin.SetParentComponent(WebPageControl1Sheet1);
    WebPanelLogin.Name := 'WebPanelLogin';
    WebPanelLogin.AlignWithMargins := True;
    WebPanelLogin.Left := 3;
    WebPanelLogin.Top := 10;
    WebPanelLogin.Width := 696;
    WebPanelLogin.Height := 1746;
    WebPanelLogin.Margins.Top := 10;
    WebPanelLogin.Center.Horizontal := True;
    WebPanelLogin.ElementClassName := 'card';
    WebPanelLogin.WidthStyle := ssPercent;
    WebPanelLogin.WidthPercent := 90.000000000000000000;
    WebPanelLogin.Align := alClient;
    WebPanelLogin.BorderColor := clNone;
    WebPanelLogin.BorderStyle := bsNone;
    WebPanelLogin.ChildOrder := 2;
    WebPanelLogin.ElementBodyClassName := 'card-body';
    WebPanelLogin.ElementFont := efCSS;
    WebPanelLogin.ShowCaption := False;
    WebPanelLogin.TabOrder := 0;
    WebLabel1.SetParentComponent(WebPanelLogin);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.AlignWithMargins := True;
    WebLabel1.Left := 3;
    WebLabel1.Top := 59;
    WebLabel1.Width := 690;
    WebLabel1.Height := 20;
    WebLabel1.Align := alTop;
    WebLabel1.Alignment := taCenter;
    WebLabel1.Caption := 'WebLabel1';
    WebLabel1.ElementFont := efCSS;
    WebLabel1.HeightStyle := ssAuto;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.HTML := '<a href="/reset-password">Forgot - Reset Password?</a>';
    WebLabel1.WidthStyle := ssPercent;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebEditLoginEmail.SetParentComponent(WebPanelLogin);
    WebEditLoginEmail.Name := 'WebEditLoginEmail';
    WebEditLoginEmail.AlignWithMargins := True;
    WebEditLoginEmail.Left := 3;
    WebEditLoginEmail.Top := 3;
    WebEditLoginEmail.Width := 690;
    WebEditLoginEmail.Height := 22;
    WebEditLoginEmail.Align := alTop;
    WebEditLoginEmail.AutoCompletion := acUserName;
    WebEditLoginEmail.Center.Horizontal := True;
    WebEditLoginEmail.ChildOrder := 1;
    WebEditLoginEmail.ElementClassName := 'form-control';
    WebEditLoginEmail.ElementFont := efCSS;
    WebEditLoginEmail.HeightStyle := ssAuto;
    WebEditLoginEmail.HeightPercent := 100.000000000000000000;
    WebEditLoginEmail.Required := True;
    WebEditLoginEmail.TextHint := 'Email';
    WebEditLoginEmail.WidthStyle := ssPercent;
    WebEditLoginEmail.WidthPercent := 90.000000000000000000;
    WebEditLoginPassword.SetParentComponent(WebPanelLogin);
    WebEditLoginPassword.Name := 'WebEditLoginPassword';
    WebEditLoginPassword.AlignWithMargins := True;
    WebEditLoginPassword.Left := 3;
    WebEditLoginPassword.Top := 31;
    WebEditLoginPassword.Width := 690;
    WebEditLoginPassword.Height := 22;
    WebEditLoginPassword.Align := alTop;
    WebEditLoginPassword.AutoCompletion := acCurrentPassword;
    WebEditLoginPassword.Center.Horizontal := True;
    WebEditLoginPassword.ChildOrder := 1;
    WebEditLoginPassword.ElementClassName := 'form-control';
    WebEditLoginPassword.ElementFont := efCSS;
    WebEditLoginPassword.HeightStyle := ssAuto;
    WebEditLoginPassword.HeightPercent := 100.000000000000000000;
    WebEditLoginPassword.PasswordChar := 'x';
    WebEditLoginPassword.Required := True;
    WebEditLoginPassword.TextHint := 'Password';
    WebEditLoginPassword.WidthStyle := ssPercent;
    WebEditLoginPassword.WidthPercent := 90.000000000000000000;
    WebButtonLogin.SetParentComponent(WebPanelLogin);
    WebButtonLogin.Name := 'WebButtonLogin';
    WebButtonLogin.AlignWithMargins := True;
    WebButtonLogin.Left := 20;
    WebButtonLogin.Top := 85;
    WebButtonLogin.Width := 656;
    WebButtonLogin.Height := 29;
    WebButtonLogin.Margins.Left := 20;
    WebButtonLogin.Margins.Right := 20;
    WebButtonLogin.Align := alTop;
    WebButtonLogin.Caption := 'Login';
    WebButtonLogin.Center.Horizontal := True;
    WebButtonLogin.ChildOrder := 3;
    WebButtonLogin.ElementClassName := 'btn btn-primary';
    WebButtonLogin.ElementFont := efCSS;
    WebButtonLogin.HeightStyle := ssAuto;
    WebButtonLogin.HeightPercent := 100.000000000000000000;
    WebButtonLogin.WidthStyle := ssPercent;
    WebButtonLogin.WidthPercent := 75.000000000000000000;
    WebPageControl1Sheet2.SetParentComponent(WebPageControlLogin);
    WebPageControl1Sheet2.Name := 'WebPageControl1Sheet2';
    WebPageControl1Sheet2.Left := 0;
    WebPageControl1Sheet2.Top := 20;
    WebPageControl1Sheet2.Width := 702;
    WebPageControl1Sheet2.Height := 1759;
    WebPageControl1Sheet2.Anchors := [akLeft,akTop,akRight,akBottom];
    WebPageControl1Sheet2.Caption := 'Signup';
    WebPageControl1Sheet2.ChildOrder := 1;
    WebPageControl1Sheet2.Color := clNone;
    WebPageControl1Sheet2.ElementFont := efCSS;
    WebPanelRegister.SetParentComponent(WebPageControl1Sheet2);
    WebPanelRegister.Name := 'WebPanelRegister';
    WebPanelRegister.AlignWithMargins := True;
    WebPanelRegister.Left := 3;
    WebPanelRegister.Top := 10;
    WebPanelRegister.Width := 696;
    WebPanelRegister.Height := 1746;
    WebPanelRegister.Margins.Top := 10;
    WebPanelRegister.Center.Horizontal := True;
    WebPanelRegister.ElementClassName := 'card';
    WebPanelRegister.WidthStyle := ssPercent;
    WebPanelRegister.WidthPercent := 90.000000000000000000;
    WebPanelRegister.Align := alClient;
    WebPanelRegister.BorderColor := clNone;
    WebPanelRegister.BorderStyle := bsNone;
    WebPanelRegister.ChildOrder := 2;
    WebPanelRegister.ElementBodyClassName := 'card-body';
    WebPanelRegister.ElementFont := efCSS;
    WebPanelRegister.ShowCaption := False;
    WebPanelRegister.TabOrder := 0;
    WebLabel2.SetParentComponent(WebPanelRegister);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.AlignWithMargins := True;
    WebLabel2.Left := 3;
    WebLabel2.Top := 158;
    WebLabel2.Width := 690;
    WebLabel2.Height := 20;
    WebLabel2.Align := alTop;
    WebLabel2.Alignment := taCenter;
    WebLabel2.Caption := 'Please enter your details and click Register';
    WebLabel2.ElementFont := efCSS;
    WebLabel2.HeightStyle := ssAuto;
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthStyle := ssPercent;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebEditRegisterEmail.SetParentComponent(WebPanelRegister);
    WebEditRegisterEmail.Name := 'WebEditRegisterEmail';
    WebEditRegisterEmail.AlignWithMargins := True;
    WebEditRegisterEmail.Left := 3;
    WebEditRegisterEmail.Top := 3;
    WebEditRegisterEmail.Width := 690;
    WebEditRegisterEmail.Height := 25;
    WebEditRegisterEmail.Align := alTop;
    WebEditRegisterEmail.AutoCompletion := acUserName;
    WebEditRegisterEmail.Center.Horizontal := True;
    WebEditRegisterEmail.ElementClassName := 'form-control';
    WebEditRegisterEmail.ElementFont := efCSS;
    WebEditRegisterEmail.HeightStyle := ssAuto;
    WebEditRegisterEmail.HeightPercent := 100.000000000000000000;
    WebEditRegisterEmail.Required := True;
    WebEditRegisterEmail.TextHint := 'Email';
    WebEditRegisterEmail.WidthStyle := ssPercent;
    WebEditRegisterEmail.WidthPercent := 90.000000000000000000;
    WebEditRegisterMobile.SetParentComponent(WebPanelRegister);
    WebEditRegisterMobile.Name := 'WebEditRegisterMobile';
    WebEditRegisterMobile.AlignWithMargins := True;
    WebEditRegisterMobile.Left := 3;
    WebEditRegisterMobile.Top := 127;
    WebEditRegisterMobile.Width := 690;
    WebEditRegisterMobile.Height := 25;
    WebEditRegisterMobile.Align := alTop;
    WebEditRegisterMobile.AutoCompletion := acTelephone;
    WebEditRegisterMobile.Center.Horizontal := True;
    WebEditRegisterMobile.ChildOrder := 1;
    WebEditRegisterMobile.ElementClassName := 'form-control';
    WebEditRegisterMobile.ElementFont := efCSS;
    WebEditRegisterMobile.HeightStyle := ssAuto;
    WebEditRegisterMobile.HeightPercent := 100.000000000000000000;
    WebEditRegisterMobile.Required := True;
    WebEditRegisterMobile.TabOrder := 4;
    WebEditRegisterMobile.TextHint := 'Mobile No';
    WebEditRegisterMobile.WidthStyle := ssPercent;
    WebEditRegisterMobile.WidthPercent := 90.000000000000000000;
    WebEditRegisterPassword.SetParentComponent(WebPanelRegister);
    WebEditRegisterPassword.Name := 'WebEditRegisterPassword';
    WebEditRegisterPassword.AlignWithMargins := True;
    WebEditRegisterPassword.Left := 3;
    WebEditRegisterPassword.Top := 34;
    WebEditRegisterPassword.Width := 690;
    WebEditRegisterPassword.Height := 25;
    WebEditRegisterPassword.Hint := 'Password';
    WebEditRegisterPassword.Align := alTop;
    WebEditRegisterPassword.AutoCompletion := acNewPassword;
    WebEditRegisterPassword.Center.Horizontal := True;
    WebEditRegisterPassword.ChildOrder := 1;
    WebEditRegisterPassword.ElementClassName := 'form-control';
    WebEditRegisterPassword.ElementFont := efCSS;
    WebEditRegisterPassword.HeightStyle := ssAuto;
    WebEditRegisterPassword.HeightPercent := 100.000000000000000000;
    WebEditRegisterPassword.Required := True;
    WebEditRegisterPassword.ShowHint := True;
    WebEditRegisterPassword.TabOrder := 1;
    WebEditRegisterPassword.TextHint := 'Password';
    WebEditRegisterPassword.WidthStyle := ssPercent;
    WebEditRegisterPassword.WidthPercent := 90.000000000000000000;
    WebEditRegisterfirstName.SetParentComponent(WebPanelRegister);
    WebEditRegisterfirstName.Name := 'WebEditRegisterfirstName';
    WebEditRegisterfirstName.AlignWithMargins := True;
    WebEditRegisterfirstName.Left := 3;
    WebEditRegisterfirstName.Top := 65;
    WebEditRegisterfirstName.Width := 690;
    WebEditRegisterfirstName.Height := 25;
    WebEditRegisterfirstName.Align := alTop;
    WebEditRegisterfirstName.AutoCompletion := acGivenName;
    WebEditRegisterfirstName.Center.Horizontal := True;
    WebEditRegisterfirstName.ChildOrder := 1;
    WebEditRegisterfirstName.ElementClassName := 'form-control';
    WebEditRegisterfirstName.ElementFont := efCSS;
    WebEditRegisterfirstName.HeightStyle := ssAuto;
    WebEditRegisterfirstName.HeightPercent := 100.000000000000000000;
    WebEditRegisterfirstName.Required := True;
    WebEditRegisterfirstName.TabOrder := 2;
    WebEditRegisterfirstName.TextHint := 'First Name';
    WebEditRegisterfirstName.WidthStyle := ssPercent;
    WebEditRegisterfirstName.WidthPercent := 90.000000000000000000;
    WebEditRegisterSurname.SetParentComponent(WebPanelRegister);
    WebEditRegisterSurname.Name := 'WebEditRegisterSurname';
    WebEditRegisterSurname.AlignWithMargins := True;
    WebEditRegisterSurname.Left := 3;
    WebEditRegisterSurname.Top := 96;
    WebEditRegisterSurname.Width := 690;
    WebEditRegisterSurname.Height := 25;
    WebEditRegisterSurname.Align := alTop;
    WebEditRegisterSurname.AutoCompletion := acCCFamilyName;
    WebEditRegisterSurname.Center.Horizontal := True;
    WebEditRegisterSurname.ChildOrder := 1;
    WebEditRegisterSurname.ElementClassName := 'form-control';
    WebEditRegisterSurname.ElementFont := efCSS;
    WebEditRegisterSurname.HeightStyle := ssAuto;
    WebEditRegisterSurname.HeightPercent := 100.000000000000000000;
    WebEditRegisterSurname.Required := True;
    WebEditRegisterSurname.TabOrder := 3;
    WebEditRegisterSurname.TextHint := 'Surname';
    WebEditRegisterSurname.WidthStyle := ssPercent;
    WebEditRegisterSurname.WidthPercent := 90.000000000000000000;
    WebButtonRegister.SetParentComponent(WebPanelRegister);
    WebButtonRegister.Name := 'WebButtonRegister';
    WebButtonRegister.AlignWithMargins := True;
    WebButtonRegister.Left := 3;
    WebButtonRegister.Top := 184;
    WebButtonRegister.Width := 690;
    WebButtonRegister.Height := 29;
    WebButtonRegister.Align := alTop;
    WebButtonRegister.Caption := 'Register';
    WebButtonRegister.Center.Horizontal := True;
    WebButtonRegister.ChildOrder := 3;
    WebButtonRegister.ElementClassName := 'btn btn-primary';
    WebButtonRegister.ElementFont := efCSS;
    WebButtonRegister.HeightStyle := ssAuto;
    WebButtonRegister.HeightPercent := 100.000000000000000000;
    WebButtonRegister.WidthStyle := ssPercent;
    WebButtonRegister.WidthPercent := 75.000000000000000000;
    SetEvent(WebButtonRegister, Self, 'OnClick', 'WebButtonRegisterClick');
    WebButton1.SetParentComponent(WebPanelRegister);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 0;
    WebButton1.Top := 216;
    WebButton1.Width := 696;
    WebButton1.Height := 25;
    WebButton1.Align := alTop;
    WebButton1.Caption := 'WebButton1';
    WebButton1.ChildOrder := 7;
    WebButton1.ElementClassName := 'btn btn-light';
    WebButton1.ElementFont := efCSS;
    WebButton1.HeightStyle := ssAuto;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WPCMainSheet5.SetParentComponent(WPCMain);
    WPCMainSheet5.Name := 'WPCMainSheet5';
    WPCMainSheet5.Left := 0;
    WPCMainSheet5.Top := 20;
    WPCMainSheet5.Width := 802;
    WPCMainSheet5.Height := 1879;
    WPCMainSheet5.Caption := 'Themes';
    WPCMainSheet5.ChildOrder := 4;
    WPCMainSheet5.Color := clNone;
    WPCMainSheet5.ElementFont := efCSS;
    WebPanel1.SetParentComponent(WPCMainSheet5);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.AlignWithMargins := True;
    WebPanel1.Left := 3;
    WebPanel1.Top := 3;
    WebPanel1.Width := 796;
    WebPanel1.Height := 1873;
    WebPanel1.ElementClassName := 'card shadow p-3 mb-5 bg-blue rounded';
    WebPanel1.WidthStyle := ssPercent;
    WebPanel1.WidthPercent := 95.000000000000000000;
    WebPanel1.Align := alClient;
    WebPanel1.ElementBodyClassName := 'card-body';
    WebPanel1.ElementFont := efCSS;
    WebPanel1.TabOrder := 0;
    WebRadioGroup1.SetParentComponent(WebPanel1);
    WebRadioGroup1.Name := 'WebRadioGroup1';
    WebRadioGroup1.AlignWithMargins := True;
    WebRadioGroup1.Left := 10;
    WebRadioGroup1.Top := 10;
    WebRadioGroup1.Width := 776;
    WebRadioGroup1.Height := 1853;
    WebRadioGroup1.Margins.Left := 10;
    WebRadioGroup1.Margins.Top := 10;
    WebRadioGroup1.Margins.Right := 10;
    WebRadioGroup1.Margins.Bottom := 10;
    WebRadioGroup1.ElementClassName := 'custom-control custom-radio';
    WebRadioGroup1.WidthStyle := ssPercent;
    WebRadioGroup1.WidthPercent := 90.000000000000000000;
    WebRadioGroup1.Align := alClient;
    WebRadioGroup1.Caption := 'Themes';
    WebRadioGroup1.Columns := 1;
    WebRadioGroup1.ElementButtonClassName := 'custom-control-input';
    WebRadioGroup1.ElementGroupClassName := 'modal-content';
    WebRadioGroup1.ElementLabelClassName := 'custom-control-label';
    WebRadioGroup1.ElementLegendClassName := 'h6';
    WebRadioGroup1.ElementFont := efCSS;
    WebRadioGroup1.ItemIndex := 0;
    WebRadioGroup1.Items.BeginUpdate;
    try
      WebRadioGroup1.Items.Clear;
      WebRadioGroup1.Items.Add('Slate Theme');
      WebRadioGroup1.Items.Add('Darkly Theme');
      WebRadioGroup1.Items.Add('Cyborg Theme');
    finally
      WebRadioGroup1.Items.EndUpdate;
    end;
    WebRadioGroup1.Role := '';
    WebRadioGroup1.TabOrder := 0;
    SetEvent(WebRadioGroup1, Self, 'OnChange', 'WebRadioGroup1Change');
    WPLeftMenu.SetParentComponent(Self);
    WPLeftMenu.Name := 'WPLeftMenu';
    WPLeftMenu.Left := 0;
    WPLeftMenu.Top := 73;
    WPLeftMenu.Width := 150;
    WPLeftMenu.Height := 1927;
    WPLeftMenu.ElementClassName := 'card';
    WPLeftMenu.Align := alLeft;
    WPLeftMenu.BorderStyle := bsNone;
    WPLeftMenu.ChildOrder := 3;
    WPLeftMenu.Color := clWindow;
    WPLeftMenu.ElementBodyClassName := 'card-body';
    WPLeftMenu.ElementFont := efCSS;
    WPLeftMenu.TabOrder := 2;
    WebLinkLabel1.SetParentComponent(WPLeftMenu);
    WebLinkLabel1.Name := 'WebLinkLabel1';
    WebLinkLabel1.AlignWithMargins := True;
    WebLinkLabel1.Left := 15;
    WebLinkLabel1.Top := 5;
    WebLinkLabel1.Width := 132;
    WebLinkLabel1.Height := 25;
    WebLinkLabel1.Margins.Left := 15;
    WebLinkLabel1.Margins.Top := 5;
    WebLinkLabel1.Margins.Bottom := 5;
    WebLinkLabel1.Align := alTop;
    WebLinkLabel1.Color := clNone;
    WebLinkLabel1.ElementFont := efCSS;
    WebLinkLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLinkLabel1.Font.Color := clWhite;
    WebLinkLabel1.Font.Height := -18;
    WebLinkLabel1.Font.Name := 'Segoe UI';
    WebLinkLabel1.Font.Style := [];
    WebLinkLabel1.ParentFont := False;
    WebLinkLabel1.HeightPercent := 100.000000000000000000;
    WebLinkLabel1.WidthPercent := 100.000000000000000000;
    SetEvent(WebLinkLabel1, Self, 'OnClick', 'WebLinkLabel1Click');
    WebLinkLabel1.Caption := 'Home Page';
    WebLinkLabel2.SetParentComponent(WPLeftMenu);
    WebLinkLabel2.Name := 'WebLinkLabel2';
    WebLinkLabel2.AlignWithMargins := True;
    WebLinkLabel2.Left := 15;
    WebLinkLabel2.Top := 40;
    WebLinkLabel2.Width := 132;
    WebLinkLabel2.Height := 25;
    WebLinkLabel2.Margins.Left := 15;
    WebLinkLabel2.Margins.Top := 5;
    WebLinkLabel2.Margins.Bottom := 5;
    WebLinkLabel2.Align := alTop;
    WebLinkLabel2.Color := clNone;
    WebLinkLabel2.ElementFont := efCSS;
    WebLinkLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLinkLabel2.Font.Color := clWhite;
    WebLinkLabel2.Font.Height := -18;
    WebLinkLabel2.Font.Name := 'Segoe UI';
    WebLinkLabel2.Font.Style := [];
    WebLinkLabel2.ParentFont := False;
    WebLinkLabel2.HeightPercent := 100.000000000000000000;
    WebLinkLabel2.WidthPercent := 100.000000000000000000;
    SetEvent(WebLinkLabel2, Self, 'OnClick', 'WebLinkLabel2Click');
    WebLinkLabel2.Caption := 'Lessons';
    WebLinkLabel3.SetParentComponent(WPLeftMenu);
    WebLinkLabel3.Name := 'WebLinkLabel3';
    WebLinkLabel3.AlignWithMargins := True;
    WebLinkLabel3.Left := 15;
    WebLinkLabel3.Top := 75;
    WebLinkLabel3.Width := 132;
    WebLinkLabel3.Height := 25;
    WebLinkLabel3.Margins.Left := 15;
    WebLinkLabel3.Margins.Top := 5;
    WebLinkLabel3.Margins.Bottom := 5;
    WebLinkLabel3.Align := alTop;
    WebLinkLabel3.Color := clNone;
    WebLinkLabel3.ElementFont := efCSS;
    WebLinkLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLinkLabel3.Font.Color := clWhite;
    WebLinkLabel3.Font.Height := -18;
    WebLinkLabel3.Font.Name := 'Segoe UI';
    WebLinkLabel3.Font.Style := [];
    WebLinkLabel3.ParentFont := False;
    WebLinkLabel3.HeightPercent := 100.000000000000000000;
    WebLinkLabel3.WidthPercent := 100.000000000000000000;
    SetEvent(WebLinkLabel3, Self, 'OnClick', 'WebLinkLabel3Click');
    WebLinkLabel3.Caption := 'Assessments';
    WebLinkLabel4.SetParentComponent(WPLeftMenu);
    WebLinkLabel4.Name := 'WebLinkLabel4';
    WebLinkLabel4.AlignWithMargins := True;
    WebLinkLabel4.Left := 15;
    WebLinkLabel4.Top := 110;
    WebLinkLabel4.Width := 132;
    WebLinkLabel4.Height := 25;
    WebLinkLabel4.Margins.Left := 15;
    WebLinkLabel4.Margins.Top := 5;
    WebLinkLabel4.Margins.Bottom := 5;
    WebLinkLabel4.Align := alTop;
    WebLinkLabel4.Color := clNone;
    WebLinkLabel4.ElementFont := efCSS;
    WebLinkLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLinkLabel4.Font.Color := clWhite;
    WebLinkLabel4.Font.Height := -18;
    WebLinkLabel4.Font.Name := 'Segoe UI';
    WebLinkLabel4.Font.Style := [];
    WebLinkLabel4.ParentFont := False;
    WebLinkLabel4.HeightPercent := 100.000000000000000000;
    WebLinkLabel4.WidthPercent := 100.000000000000000000;
    SetEvent(WebLinkLabel4, Self, 'OnClick', 'WebLinkLabel4Click');
    WebLinkLabel4.Caption := 'Login / Signup';
    WebLinkLabel5.SetParentComponent(WPLeftMenu);
    WebLinkLabel5.Name := 'WebLinkLabel5';
    WebLinkLabel5.AlignWithMargins := True;
    WebLinkLabel5.Left := 15;
    WebLinkLabel5.Top := 145;
    WebLinkLabel5.Width := 132;
    WebLinkLabel5.Height := 25;
    WebLinkLabel5.Margins.Left := 15;
    WebLinkLabel5.Margins.Top := 5;
    WebLinkLabel5.Margins.Bottom := 5;
    WebLinkLabel5.Align := alTop;
    WebLinkLabel5.Color := clNone;
    WebLinkLabel5.ElementFont := efCSS;
    WebLinkLabel5.Font.Charset := DEFAULT_CHARSET;
    WebLinkLabel5.Font.Color := clWhite;
    WebLinkLabel5.Font.Height := -18;
    WebLinkLabel5.Font.Name := 'Segoe UI';
    WebLinkLabel5.Font.Style := [];
    WebLinkLabel5.ParentFont := False;
    WebLinkLabel5.HeightPercent := 100.000000000000000000;
    WebLinkLabel5.WidthPercent := 100.000000000000000000;
    SetEvent(WebLinkLabel5, Self, 'OnClick', 'WebLinkLabel5Click');
    WebLinkLabel5.Caption := 'Theme';
    WebHttpRequestRegister.SetParentComponent(Self);
    WebHttpRequestRegister.Name := 'WebHttpRequestRegister';
    WebHttpRequestRegister.Command := httpPOST;
    WebHttpRequestRegister.ResponseType := rtText;
    WebHttpRequestRegister.URL := 'https://wilsea.com/python11/register';
    SetEvent(WebHttpRequestRegister, Self, 'OnError', 'WebHttpRequestRegisterError');
    SetEvent(WebHttpRequestRegister, Self, 'OnResponse', 'WebHttpRequestRegisterResponse');
    SetEvent(WebHttpRequestRegister, Self, 'OnRequestResponse', 'WebHttpRequestRegisterRequestResponse');
    WebHttpRequestRegister.Left := 672;
    WebHttpRequestRegister.Top := 80;
  finally
    WebPanel10.AfterLoadDFMValues;
    WebImageHamburgerLeft.AfterLoadDFMValues;
    WebImageLogo.AfterLoadDFMValues;
    WebImageHamburgerRight.AfterLoadDFMValues;
    WPTopMenus.AfterLoadDFMValues;
    WebHTMLContainer9.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WPCMain.AfterLoadDFMValues;
    WebPageControlHome.AfterLoadDFMValues;
    WRGMain.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebHTMLContainer1.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebHTMLContainer2.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    WebYoutube2.AfterLoadDFMValues;
    WebPanel5.AfterLoadDFMValues;
    WebHTMLContainer3.AfterLoadDFMValues;
    WebPanel6.AfterLoadDFMValues;
    WebHTMLContainer5.AfterLoadDFMValues;
    WebPanel7.AfterLoadDFMValues;
    WebHTMLContainer6.AfterLoadDFMValues;
    WebPanel8.AfterLoadDFMValues;
    WebButton3.AfterLoadDFMValues;
    WebPanel9.AfterLoadDFMValues;
    WebImageControl1.AfterLoadDFMValues;
    WebPageControlSheetOther.AfterLoadDFMValues;
    WebResponsiveGridPanel1.AfterLoadDFMValues;
    WebPanel11.AfterLoadDFMValues;
    WebBrowserControl1.AfterLoadDFMValues;
    WebPanel12.AfterLoadDFMValues;
    WebBrowserControl2.AfterLoadDFMValues;
    WebPanel13.AfterLoadDFMValues;
    WebPanel14.AfterLoadDFMValues;
    WebPanel15.AfterLoadDFMValues;
    WebPanel16.AfterLoadDFMValues;
    WebPanel17.AfterLoadDFMValues;
    WebPanel18.AfterLoadDFMValues;
    WebResponsiveGridPanel3.AfterLoadDFMValues;
    WebPanel26.AfterLoadDFMValues;
    WebHTMLContainer4.AfterLoadDFMValues;
    WebPanel27.AfterLoadDFMValues;
    WebHTMLContainer20.AfterLoadDFMValues;
    WebPanel28.AfterLoadDFMValues;
    WebHTMLContainer26.AfterLoadDFMValues;
    WebPanel29.AfterLoadDFMValues;
    WebHTMLContainer27.AfterLoadDFMValues;
    WebPanel30.AfterLoadDFMValues;
    WebHTMLContainer28.AfterLoadDFMValues;
    WebPanel31.AfterLoadDFMValues;
    WebHTMLContainer29.AfterLoadDFMValues;
    WebPanel32.AfterLoadDFMValues;
    WebHTMLContainer30.AfterLoadDFMValues;
    WebPanel33.AfterLoadDFMValues;
    WebHTMLContainer31.AfterLoadDFMValues;
    WebPageControlSheetLessons.AfterLoadDFMValues;
    WebResponsiveGridPanel2.AfterLoadDFMValues;
    WebPanel19.AfterLoadDFMValues;
    WebBrowserControl5.AfterLoadDFMValues;
    WebPanel20.AfterLoadDFMValues;
    WebBrowserControl8.AfterLoadDFMValues;
    WebPanel21.AfterLoadDFMValues;
    WebHTMLContainer12.AfterLoadDFMValues;
    WebPanel22.AfterLoadDFMValues;
    WebHTMLContainer13.AfterLoadDFMValues;
    WebPanel23.AfterLoadDFMValues;
    WebHTMLContainer7.AfterLoadDFMValues;
    WebPanel24.AfterLoadDFMValues;
    WebHTMLContainer8.AfterLoadDFMValues;
    WebPanel25.AfterLoadDFMValues;
    WebHTMLContainer10.AfterLoadDFMValues;
    WebPanel34.AfterLoadDFMValues;
    WebHTMLContainer11.AfterLoadDFMValues;
    WPCMainSheetLogin.AfterLoadDFMValues;
    WebPanel35.AfterLoadDFMValues;
    WebPageControlLogin.AfterLoadDFMValues;
    WebPageControl1Sheet1.AfterLoadDFMValues;
    WebPanelLogin.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebEditLoginEmail.AfterLoadDFMValues;
    WebEditLoginPassword.AfterLoadDFMValues;
    WebButtonLogin.AfterLoadDFMValues;
    WebPageControl1Sheet2.AfterLoadDFMValues;
    WebPanelRegister.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebEditRegisterEmail.AfterLoadDFMValues;
    WebEditRegisterMobile.AfterLoadDFMValues;
    WebEditRegisterPassword.AfterLoadDFMValues;
    WebEditRegisterfirstName.AfterLoadDFMValues;
    WebEditRegisterSurname.AfterLoadDFMValues;
    WebButtonRegister.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WPCMainSheet5.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    WebRadioGroup1.AfterLoadDFMValues;
    WPLeftMenu.AfterLoadDFMValues;
    WebLinkLabel1.AfterLoadDFMValues;
    WebLinkLabel2.AfterLoadDFMValues;
    WebLinkLabel3.AfterLoadDFMValues;
    WebLinkLabel4.AfterLoadDFMValues;
    WebLinkLabel5.AfterLoadDFMValues;
    WebHttpRequestRegister.AfterLoadDFMValues;
  end;
end;

end.